import { default as advertiser_45disclosurejsNPx8xUeVMeta } from "/frontend/pages/advertiser-disclosure.vue?macro=true";
import { default as attempted_45redirect88PO14cOTcMeta } from "/frontend/pages/attempted-redirect.vue?macro=true";
import { default as _questionSqJH9444ysMeta } from "/frontend/pages/basic-info-new/_question.vue?macro=true";
import { default as index7pZ3iExbt9Meta } from "/frontend/pages/basic-info-new/index.vue?macro=true";
import { default as basic_45info_45newHoULjU69jtMeta } from "/frontend/pages/basic-info-new.vue?macro=true";
import { default as basic_45infoDzcr9nwUJeMeta } from "/frontend/pages/basic-info.vue?macro=true";
import { default as business_45info_452ye45FvV6ZCMeta } from "/frontend/pages/business-info/business-info-2.vue?macro=true";
import { default as business_45info_453UqneT3WhnGMeta } from "/frontend/pages/business-info/business-info-3.vue?macro=true";
import { default as indexDtPqBtQkypMeta } from "/frontend/pages/business-info/index.vue?macro=true";
import { default as business_45infodkOlzTtbLRMeta } from "/frontend/pages/business-info.vue?macro=true";
import { default as cookie_45testcfdhiCsSdRMeta } from "/frontend/pages/cookie-test.vue?macro=true";
import { default as credit_45card_45widgetfK0U7yA4rtMeta } from "/frontend/pages/credit-card-widget.vue?macro=true";
import { default as accountsgsRheWhf0nMeta } from "/frontend/pages/documents/accounts.vue?macro=true";
import { default as indexh0uHHDGrcXMeta } from "/frontend/pages/documents/index.vue?macro=true";
import { default as manualpXUaRzPlVGMeta } from "/frontend/pages/documents/manual.vue?macro=true";
import { default as resultsJ9KacGQTnxMeta } from "/frontend/pages/documents/results.vue?macro=true";
import { default as statement_45errorQbRqjBCGhsMeta } from "/frontend/pages/documents/statement-error.vue?macro=true";
import { default as sync_45errorjFh9EXdvwbMeta } from "/frontend/pages/documents/sync-error.vue?macro=true";
import { default as syncnpIKBVbFQ2Meta } from "/frontend/pages/documents/sync.vue?macro=true";
import { default as documentsxY6dxfn9neMeta } from "/frontend/pages/documents.vue?macro=true";
import { default as _91error_93dvDgwrqXJrMeta } from "/frontend/pages/embedded/[error].vue?macro=true";
import { default as business_45info7yDaQxvmOMMeta } from "/frontend/pages/embedded/business-info.vue?macro=true";
import { default as credit_45check_45result1Z4e49d7ThMeta } from "/frontend/pages/embedded/credit-check-result.vue?macro=true";
import { default as credit_45check3Awa0aP5EAMeta } from "/frontend/pages/embedded/credit-check.vue?macro=true";
import { default as accountsEkSb1nVWz6Meta } from "/frontend/pages/embedded/documents/accounts.vue?macro=true";
import { default as indexdD0CTBRNpPMeta } from "/frontend/pages/embedded/documents/index.vue?macro=true";
import { default as manualpKHG85MNwbMeta } from "/frontend/pages/embedded/documents/manual.vue?macro=true";
import { default as resultshQLsm0iXzWMeta } from "/frontend/pages/embedded/documents/results.vue?macro=true";
import { default as statement_45errorSkNtKkB1hQMeta } from "/frontend/pages/embedded/documents/statement-error.vue?macro=true";
import { default as sync_45error9qRnqZAvlkMeta } from "/frontend/pages/embedded/documents/sync-error.vue?macro=true";
import { default as synckoyPDKpwQ9Meta } from "/frontend/pages/embedded/documents/sync.vue?macro=true";
import { default as documentsUQeA57NRfBMeta } from "/frontend/pages/embedded/documents.vue?macro=true";
import { default as indexchSby0TNSqMeta } from "/frontend/pages/embedded/index.vue?macro=true";
import { default as accountsAFWPCBFbYoMeta } from "/frontend/pages/embedded/portal/accounts.vue?macro=true";
import { default as dashboardeh4LK1QW7WMeta } from "/frontend/pages/embedded/portal/dashboard.vue?macro=true";
import { default as documentsHNhBpJpOPYMeta } from "/frontend/pages/embedded/portal/documents.vue?macro=true";
import { default as indexDmmXcsu9TfMeta } from "/frontend/pages/embedded/portal/index.vue?macro=true";
import { default as resultsNwZBoLUC6GMeta } from "/frontend/pages/embedded/portal/results.vue?macro=true";
import { default as statement_45errorwwGlXAmkTyMeta } from "/frontend/pages/embedded/portal/statement-error.vue?macro=true";
import { default as sync_45errorQU1sEo7jEoMeta } from "/frontend/pages/embedded/portal/sync-error.vue?macro=true";
import { default as syncmOoHkuBdlrMeta } from "/frontend/pages/embedded/portal/sync.vue?macro=true";
import { default as portalRSWM0J4ABqMeta } from "/frontend/pages/embedded/portal.vue?macro=true";
import { default as submitSZwfFSA2H8Meta } from "/frontend/pages/embedded/submit.vue?macro=true";
import { default as basic_45info4merkD28IdMeta } from "/frontend/pages/erc/basic-info.vue?macro=true";
import { default as business_45infoVSzfnR0bL7Meta } from "/frontend/pages/erc/business-info.vue?macro=true";
import { default as checklistbBEB1DliLMMeta } from "/frontend/pages/erc/checklist.vue?macro=true";
import { default as final_45erc_45affiliatenZKRMbgpD7Meta } from "/frontend/pages/erc/final-erc-affiliate.vue?macro=true";
import { default as final_45ercQkymtmWRHcMeta } from "/frontend/pages/erc/final-erc.vue?macro=true";
import { default as government_45order_45infoB4rVQLNNpMMeta } from "/frontend/pages/erc/government-order-info.vue?macro=true";
import { default as capacity_45limitationCprQ3v93KzMeta } from "/frontend/pages/erc/government-order/capacity-limitation.vue?macro=true";
import { default as government_45order_452NNizlhJ15WMeta } from "/frontend/pages/erc/government-order/government-order-2.vue?macro=true";
import { default as government_45order_453H0xi2sed1uMeta } from "/frontend/pages/erc/government-order/government-order-3.vue?macro=true";
import { default as in_45person_45meetings_45affected7FUMkgaPC9Meta } from "/frontend/pages/erc/government-order/in-person-meetings-affected.vue?macro=true";
import { default as indexfQuox16s0SMeta } from "/frontend/pages/erc/government-order/index.vue?macro=true";
import { default as prevented_45customer_45accesszZpBd0OF0jMeta } from "/frontend/pages/erc/government-order/prevented-customer-access.vue?macro=true";
import { default as production_45declinedumr2nJVMAzMeta } from "/frontend/pages/erc/government-order/production-declined.vue?macro=true";
import { default as projects_45affectedYhvi9fm73wMeta } from "/frontend/pages/erc/government-order/projects-affected.vue?macro=true";
import { default as reduced_45hours2L9fpKYR6vMeta } from "/frontend/pages/erc/government-order/reduced-hours.vue?macro=true";
import { default as reduction_45in_45contractsbBqn6S9CmwMeta } from "/frontend/pages/erc/government-order/reduction-in-contracts.vue?macro=true";
import { default as reduction_45in_45customers_45servedTEqUKeXS0lMeta } from "/frontend/pages/erc/government-order/reduction-in-customers-served.vue?macro=true";
import { default as sales_45reducedhRQF654dqxMeta } from "/frontend/pages/erc/government-order/sales-reduced.vue?macro=true";
import { default as staggered_45shiftsc1OL68XoaYMeta } from "/frontend/pages/erc/government-order/staggered-shifts.vue?macro=true";
import { default as suppliers_45shutdowni8psYV1XZKMeta } from "/frontend/pages/erc/government-order/suppliers-shutdown.vue?macro=true";
import { default as workspace_45modificationsRYUF1tRG78Meta } from "/frontend/pages/erc/government-order/workspace-modifications.vue?macro=true";
import { default as grant_45credit_45infoar4B8tPj4rMeta } from "/frontend/pages/erc/grant-credit-info.vue?macro=true";
import { default as indexIVXhYbD5PfMeta } from "/frontend/pages/erc/index.vue?macro=true";
import { default as ownership_45info_45tenantdpdPrhXxSdMeta } from "/frontend/pages/erc/ownership-info-tenant.vue?macro=true";
import { default as additional_45businessesAu71Ek6tpMMeta } from "/frontend/pages/erc/ownership-info/additional-businesses.vue?macro=true";
import { default as indexjsZCXVCdDAMeta } from "/frontend/pages/erc/ownership-info/index.vue?macro=true";
import { default as owner_45related_45employeesZ0rbHal0oHMeta } from "/frontend/pages/erc/ownership-info/owner-related-employees.vue?macro=true";
import { default as ownership_45mixin0DCp25IDOlMeta } from "/frontend/pages/erc/ownership-info/ownership-mixin.js?macro=true";
import { default as related_45ownersyZN4OuGdxdMeta } from "/frontend/pages/erc/ownership-info/related-owners.vue?macro=true";
import { default as spouse_45owned_45businesseslgEf2OwPMoMeta } from "/frontend/pages/erc/ownership-info/spouse-owned-businesses.vue?macro=true";
import { default as partner_45ercuVNtPYU8IvMeta } from "/frontend/pages/erc/partner-erc.vue?macro=true";
import { default as indexcf3nMXJwZkMeta } from "/frontend/pages/erc/payroll/index.vue?macro=true";
import { default as manualpXLgbEnlHZMeta } from "/frontend/pages/erc/payroll/manual.vue?macro=true";
import { default as peo_45infoqETSjFk6vrMeta } from "/frontend/pages/erc/peo-info.vue?macro=true";
import { default as ppp_45infoTdCb4t55A3Meta } from "/frontend/pages/erc/ppp-info.vue?macro=true";
import { default as qualificationsP6nxDqI4rTMeta } from "/frontend/pages/erc/qualifications.vue?macro=true";
import { default as revenue_45info6FohQ6COgdMeta } from "/frontend/pages/erc/revenue-info.vue?macro=true";
import { default as tax_45documentsHtRnLUX9PtMeta } from "/frontend/pages/erc/tax-documents.vue?macro=true";
import { default as _91_91slug_93_939TAq515AaeMeta } from "/frontend/pages/form/[identifier]/[[slug]].vue?macro=true";
import { default as _91identifier_93FVM4rVYc0dMeta } from "/frontend/pages/form/[identifier].vue?macro=true";
import { default as indexPu9Tcx6ecrMeta } from "/frontend/pages/form/index.vue?macro=true";
import { default as indexHkHAubw5j8Meta } from "/frontend/pages/funding-needs/index.vue?macro=true";
import { default as healthcheckbv1LGjf6NUMeta } from "/frontend/pages/healthcheck.vue?macro=true";
import { default as indexJfWOMM8EtJMeta } from "/frontend/pages/intelligent-lending/index.vue?macro=true";
import { default as dashboardSeKN9pUciRMeta } from "/frontend/pages/intelligent-lending/portal/dashboard.vue?macro=true";
import { default as documentsIzMRM2gVbsMeta } from "/frontend/pages/intelligent-lending/portal/documents.vue?macro=true";
import { default as indexbkxclBPk6qMeta } from "/frontend/pages/intelligent-lending/portal/index.vue?macro=true";
import { default as portalhqQ0UlkrPyMeta } from "/frontend/pages/intelligent-lending/portal.vue?macro=true";
import { default as lender_45review94KxSNVaeEMeta } from "/frontend/pages/lender-review.vue?macro=true";
import { default as login_45errorPBF9SWGCCQMeta } from "/frontend/pages/login-error.vue?macro=true";
import { default as login_45ssothNWmAfhDJMeta } from "/frontend/pages/login-sso.vue?macro=true";
import { default as login8M9opu3hOuMeta } from "/frontend/pages/login.vue?macro=true";
import { default as multiselect9a3Y25LZ1fMeta } from "/frontend/pages/multiselect.vue?macro=true";
import { default as newpassWcC54p5HkoMeta } from "/frontend/pages/newpass.vue?macro=true";
import { default as indexAn57psqaiqMeta } from "/frontend/pages/owner-info/index.vue?macro=true";
import { default as owner_45info_452tSbNxPOGknMeta } from "/frontend/pages/owner-info/owner-info-2.vue?macro=true";
import { default as owner_45info_453Kn831IpHJtMeta } from "/frontend/pages/owner-info/owner-info-3.vue?macro=true";
import { default as owner_45info_454hTfGvm5Y3vMeta } from "/frontend/pages/owner-info/owner-info-4.vue?macro=true";
import { default as owner_45info2KYri6P3WaMeta } from "/frontend/pages/owner-info.vue?macro=true";
import { default as adjust_45offer0tKAHoVh63Meta } from "/frontend/pages/portal/adjust-offer.vue?macro=true";
import { default as business_45resourcesYIhoRNbZsVMeta } from "/frontend/pages/portal/business-resources.vue?macro=true";
import { default as closingXm5dRSFiQsMeta } from "/frontend/pages/portal/closing.vue?macro=true";
import { default as credit_45cardsq6uVui8cDqMeta } from "/frontend/pages/portal/credit-cards.vue?macro=true";
import { default as DnqCta5HrT2kA7GgMeta } from "/frontend/pages/portal/DnqCta.vue?macro=true";
import { default as documentsdPqoFiu7CmMeta } from "/frontend/pages/portal/documents.vue?macro=true";
import { default as explore_45other_45productsdpTSfVCcVpMeta } from "/frontend/pages/portal/explore-other-products.vue?macro=true";
import { default as indexF1HJUHW20QMeta } from "/frontend/pages/portal/index.vue?macro=true";
import { default as loan_45offersFKsd2lfUxAMeta } from "/frontend/pages/portal/loan-offers.vue?macro=true";
import { default as offers_452_45confirmationnGGKyc9fc0Meta } from "/frontend/pages/portal/offers-2-confirmation.vue?macro=true";
import { default as offersz0LfXc9D2MMeta } from "/frontend/pages/portal/offers.vue?macro=true";
import { default as settings5sIbnpQoHEMeta } from "/frontend/pages/portal/settings.vue?macro=true";
import { default as sunrise_45appPIozIqG1FNMeta } from "/frontend/pages/portal/sunrise-app.vue?macro=true";
import { default as portalR1NlEqQJ5wMeta } from "/frontend/pages/portal.vue?macro=true";
import { default as pwf_45signupU2NgfyoH3zMeta } from "/frontend/pages/pwf-signup.vue?macro=true";
import { default as redirect_45from_45lendio63iIIqTkwVMeta } from "/frontend/pages/redirect-from-lendio.vue?macro=true";
import { default as _91rep_93i3HhxNXpUNMeta } from "/frontend/pages/referral/[rep].vue?macro=true";
import { default as thank_45youZv2ZsJW0QBMeta } from "/frontend/pages/referral/thank-you.vue?macro=true";
import { default as business_45infog69EM4f4MfMeta } from "/frontend/pages/renewal/business-info.vue?macro=true";
import { default as indexOF4KfvoBkjMeta } from "/frontend/pages/renewal/credit-check/index.vue?macro=true";
import { default as review86rwEbeEUCMeta } from "/frontend/pages/renewal/credit-check/review.vue?macro=true";
import { default as indexwuwXaQUxLKMeta } from "/frontend/pages/renewal/documents/index.vue?macro=true";
import { default as manualBKkdQ364iJMeta } from "/frontend/pages/renewal/documents/manual.vue?macro=true";
import { default as index54uuNy4VEFMeta } from "/frontend/pages/renewal/index.vue?macro=true";
import { default as new_45loan_45requirementsWGOaig5S9hMeta } from "/frontend/pages/renewal/new-loan-requirements.vue?macro=true";
import { default as submit3I3Js5gsuuMeta } from "/frontend/pages/renewal/submit.vue?macro=true";
import { default as resetu6sanXCFsXMeta } from "/frontend/pages/reset.vue?macro=true";
import { default as resume_45appH984Kab6AOMeta } from "/frontend/pages/resume-app.vue?macro=true";
import { default as rollbarGJN2plsEGFMeta } from "/frontend/pages/rollbar.vue?macro=true";
import { default as indexMQq7rtVUSrMeta } from "/frontend/pages/sba-complete/index.vue?macro=true";
import { default as documentsztADxtGTBZMeta } from "/frontend/pages/sba-complete/portal/documents.vue?macro=true";
import { default as indexZHNPdw7d0ZMeta } from "/frontend/pages/sba-complete/portal/index.vue?macro=true";
import { default as balance_45sheet1S6lYN2vmqMeta } from "/frontend/pages/sba/balance-sheet.vue?macro=true";
import { default as debt_45schedule_45uploadAlfTOxkjgwMeta } from "/frontend/pages/sba/debt-schedule-upload.vue?macro=true";
import { default as debt_45schedule9mdCCkYCK2Meta } from "/frontend/pages/sba/debt-schedule.vue?macro=true";
import { default as profit_45and_45lossDyKr3vKSKfMeta } from "/frontend/pages/sba/profit-and-loss.vue?macro=true";
import { default as tax_45returnsotxjqeb9AhMeta } from "/frontend/pages/sba/tax-returns.vue?macro=true";
import { default as sso_45signupOEO6xqeesmMeta } from "/frontend/pages/sso-signup.vue?macro=true";
import { default as submitBODkFOXSPpMeta } from "/frontend/pages/submit.vue?macro=true";
import { default as testjR5Xy3x4lTMeta } from "/frontend/pages/test.vue?macro=true";
import { default as tokenBO4C5yC0yNMeta } from "/frontend/pages/token.vue?macro=true";
import { default as under_45reviewmPSkg1xwVHMeta } from "/frontend/pages/under-review.vue?macro=true";
import { default as indexv41VKvYPDOMeta } from "/frontend/pages/updated-info/index.vue?macro=true";
import { default as updated_45info7LsO9mvLTiMeta } from "/frontend/pages/updated-info.vue?macro=true";
import { default as finicityvTSVc8gjY2Meta } from "/frontend/pages/upload/finicity.vue?macro=true";
import { default as indexvZohKRy7JmMeta } from "/frontend/pages/upload/index.vue?macro=true";
import { default as manualz1eH6QsiToMeta } from "/frontend/pages/upload/manual.vue?macro=true";
import { default as requestsTHo3oqd24tMeta } from "/frontend/pages/upload/requests.vue?macro=true";
import { default as verify_45emailDl62eZnYUQMeta } from "/frontend/pages/verify-email.vue?macro=true";
import { default as waypoint_450B1SCUtwCcYMeta } from "/frontend/pages/waypoint-0.vue?macro=true";
import { default as waypoint_451v7Lt1D1z87Meta } from "/frontend/pages/waypoint-1.vue?macro=true";
import { default as basic_45infoDQJXFbq5CEMeta } from "~/pages/basic-info.vue?macro=true";
import { default as indexp05jsjiaBTMeta } from "~/pages/owner-info/index.vue?macro=true";
import { default as owner_45info_452EvTXma01J1Meta } from "~/pages/owner-info/owner-info-2.vue?macro=true";
import { default as owner_45info_4535fmFXPdRD4Meta } from "~/pages/owner-info/owner-info-3.vue?macro=true";
import { default as owner_45infocX1MkwIYvpMeta } from "~/pages/owner-info.vue?macro=true";
import { default as indexnWue2NkKc8Meta } from "~/pages/business-info/index.vue?macro=true";
import { default as business_45info_452pixnYywCPkMeta } from "~/pages/business-info/business-info-2.vue?macro=true";
import { default as business_45info_4537WPrrOBWBiMeta } from "~/pages/business-info/business-info-3.vue?macro=true";
import { default as business_45infoWMSuu4bQfQMeta } from "~/pages/business-info.vue?macro=true";
import { default as indexMOOjPajTGGMeta } from "~/pages/documents/index.vue?macro=true";
import { default as accountsrMx7FFEkSsMeta } from "~/pages/documents/accounts.vue?macro=true";
import { default as manual45bRhVj1d6Meta } from "~/pages/documents/manual.vue?macro=true";
import { default as results7PbqIUioVBMeta } from "~/pages/documents/results.vue?macro=true";
import { default as statement_45errorIi6aDKPvdBMeta } from "~/pages/documents/statement-error.vue?macro=true";
import { default as sync_45errorfspmeCkScfMeta } from "~/pages/documents/sync-error.vue?macro=true";
import { default as syncOcFHWDYP2RMeta } from "~/pages/documents/sync.vue?macro=true";
import { default as documentsSBpLC342UmMeta } from "~/pages/documents.vue?macro=true";
import { default as tax_45returnsglKvLKSewvMeta } from "~/pages/sba/tax-returns.vue?macro=true";
import { default as debt_45scheduleICMfs2VJXSMeta } from "~/pages/sba/debt-schedule.vue?macro=true";
import { default as debt_45schedule_45uploadKdnClmSlK7Meta } from "~/pages/sba/debt-schedule-upload.vue?macro=true";
import { default as profit_45and_45loss6KYt05WFPHMeta } from "~/pages/sba/profit-and-loss.vue?macro=true";
import { default as balance_45sheetcOMazjXBgiMeta } from "~/pages/sba/balance-sheet.vue?macro=true";
import { default as submit7M2ZAdLQ6OMeta } from "~/pages/embedded/submit.vue?macro=true";
export default [
  {
    name: advertiser_45disclosurejsNPx8xUeVMeta?.name ?? "advertiser-disclosure",
    path: advertiser_45disclosurejsNPx8xUeVMeta?.path ?? "/advertiser-disclosure",
    meta: advertiser_45disclosurejsNPx8xUeVMeta || {},
    alias: advertiser_45disclosurejsNPx8xUeVMeta?.alias || [],
    redirect: advertiser_45disclosurejsNPx8xUeVMeta?.redirect,
    component: () => import("/frontend/pages/advertiser-disclosure.vue").then(m => m.default || m)
  },
  {
    name: attempted_45redirect88PO14cOTcMeta?.name ?? "attempted-redirect",
    path: attempted_45redirect88PO14cOTcMeta?.path ?? "/attempted-redirect",
    meta: attempted_45redirect88PO14cOTcMeta || {},
    alias: attempted_45redirect88PO14cOTcMeta?.alias || [],
    redirect: attempted_45redirect88PO14cOTcMeta?.redirect,
    component: () => import("/frontend/pages/attempted-redirect.vue").then(m => m.default || m)
  },
  {
    name: basic_45info_45newHoULjU69jtMeta?.name ?? undefined,
    path: basic_45info_45newHoULjU69jtMeta?.path ?? "/basic-info-new",
    meta: basic_45info_45newHoULjU69jtMeta || {},
    alias: basic_45info_45newHoULjU69jtMeta?.alias || [],
    redirect: basic_45info_45newHoULjU69jtMeta?.redirect,
    component: () => import("/frontend/pages/basic-info-new.vue").then(m => m.default || m),
    children: [
  {
    name: _questionSqJH9444ysMeta?.name ?? "basic-info-new-_question",
    path: _questionSqJH9444ysMeta?.path ?? "_question",
    meta: _questionSqJH9444ysMeta || {},
    alias: _questionSqJH9444ysMeta?.alias || [],
    redirect: _questionSqJH9444ysMeta?.redirect,
    component: () => import("/frontend/pages/basic-info-new/_question.vue").then(m => m.default || m)
  },
  {
    name: index7pZ3iExbt9Meta?.name ?? "basic-info-new",
    path: index7pZ3iExbt9Meta?.path ?? "",
    meta: index7pZ3iExbt9Meta || {},
    alias: index7pZ3iExbt9Meta?.alias || [],
    redirect: index7pZ3iExbt9Meta?.redirect,
    component: () => import("/frontend/pages/basic-info-new/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: basic_45infoDzcr9nwUJeMeta?.name ?? "basic-info",
    path: basic_45infoDzcr9nwUJeMeta?.path ?? "/basic-info",
    meta: basic_45infoDzcr9nwUJeMeta || {},
    alias: basic_45infoDzcr9nwUJeMeta?.alias || [],
    redirect: basic_45infoDzcr9nwUJeMeta?.redirect,
    component: () => import("/frontend/pages/basic-info.vue").then(m => m.default || m)
  },
  {
    name: business_45infodkOlzTtbLRMeta?.name ?? undefined,
    path: business_45infodkOlzTtbLRMeta?.path ?? "/business-info",
    meta: business_45infodkOlzTtbLRMeta || {},
    alias: business_45infodkOlzTtbLRMeta?.alias || [],
    redirect: business_45infodkOlzTtbLRMeta?.redirect,
    component: () => import("/frontend/pages/business-info.vue").then(m => m.default || m),
    children: [
  {
    name: business_45info_452ye45FvV6ZCMeta?.name ?? "business-info-business-info-2",
    path: business_45info_452ye45FvV6ZCMeta?.path ?? "business-info-2",
    meta: business_45info_452ye45FvV6ZCMeta || {},
    alias: business_45info_452ye45FvV6ZCMeta?.alias || [],
    redirect: business_45info_452ye45FvV6ZCMeta?.redirect,
    component: () => import("/frontend/pages/business-info/business-info-2.vue").then(m => m.default || m)
  },
  {
    name: business_45info_453UqneT3WhnGMeta?.name ?? "business-info-business-info-3",
    path: business_45info_453UqneT3WhnGMeta?.path ?? "business-info-3",
    meta: business_45info_453UqneT3WhnGMeta || {},
    alias: business_45info_453UqneT3WhnGMeta?.alias || [],
    redirect: business_45info_453UqneT3WhnGMeta?.redirect,
    component: () => import("/frontend/pages/business-info/business-info-3.vue").then(m => m.default || m)
  },
  {
    name: indexDtPqBtQkypMeta?.name ?? "business-info",
    path: indexDtPqBtQkypMeta?.path ?? "",
    meta: indexDtPqBtQkypMeta || {},
    alias: indexDtPqBtQkypMeta?.alias || [],
    redirect: indexDtPqBtQkypMeta?.redirect,
    component: () => import("/frontend/pages/business-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: cookie_45testcfdhiCsSdRMeta?.name ?? "cookie-test",
    path: cookie_45testcfdhiCsSdRMeta?.path ?? "/cookie-test",
    meta: cookie_45testcfdhiCsSdRMeta || {},
    alias: cookie_45testcfdhiCsSdRMeta?.alias || [],
    redirect: cookie_45testcfdhiCsSdRMeta?.redirect,
    component: () => import("/frontend/pages/cookie-test.vue").then(m => m.default || m)
  },
  {
    name: credit_45card_45widgetfK0U7yA4rtMeta?.name ?? "credit-card-widget",
    path: credit_45card_45widgetfK0U7yA4rtMeta?.path ?? "/credit-card-widget",
    meta: credit_45card_45widgetfK0U7yA4rtMeta || {},
    alias: credit_45card_45widgetfK0U7yA4rtMeta?.alias || [],
    redirect: credit_45card_45widgetfK0U7yA4rtMeta?.redirect,
    component: () => import("/frontend/pages/credit-card-widget.vue").then(m => m.default || m)
  },
  {
    name: documentsxY6dxfn9neMeta?.name ?? undefined,
    path: documentsxY6dxfn9neMeta?.path ?? "/documents",
    meta: documentsxY6dxfn9neMeta || {},
    alias: documentsxY6dxfn9neMeta?.alias || [],
    redirect: documentsxY6dxfn9neMeta?.redirect,
    component: () => import("/frontend/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: accountsgsRheWhf0nMeta?.name ?? "documents-accounts",
    path: accountsgsRheWhf0nMeta?.path ?? "accounts",
    meta: accountsgsRheWhf0nMeta || {},
    alias: accountsgsRheWhf0nMeta?.alias || [],
    redirect: accountsgsRheWhf0nMeta?.redirect,
    component: () => import("/frontend/pages/documents/accounts.vue").then(m => m.default || m)
  },
  {
    name: indexh0uHHDGrcXMeta?.name ?? "documents",
    path: indexh0uHHDGrcXMeta?.path ?? "",
    meta: indexh0uHHDGrcXMeta || {},
    alias: indexh0uHHDGrcXMeta?.alias || [],
    redirect: indexh0uHHDGrcXMeta?.redirect,
    component: () => import("/frontend/pages/documents/index.vue").then(m => m.default || m)
  },
  {
    name: manualpXUaRzPlVGMeta?.name ?? "documents-manual",
    path: manualpXUaRzPlVGMeta?.path ?? "manual",
    meta: manualpXUaRzPlVGMeta || {},
    alias: manualpXUaRzPlVGMeta?.alias || [],
    redirect: manualpXUaRzPlVGMeta?.redirect,
    component: () => import("/frontend/pages/documents/manual.vue").then(m => m.default || m)
  },
  {
    name: resultsJ9KacGQTnxMeta?.name ?? "documents-results",
    path: resultsJ9KacGQTnxMeta?.path ?? "results",
    meta: resultsJ9KacGQTnxMeta || {},
    alias: resultsJ9KacGQTnxMeta?.alias || [],
    redirect: resultsJ9KacGQTnxMeta?.redirect,
    component: () => import("/frontend/pages/documents/results.vue").then(m => m.default || m)
  },
  {
    name: statement_45errorQbRqjBCGhsMeta?.name ?? "documents-statement-error",
    path: statement_45errorQbRqjBCGhsMeta?.path ?? "statement-error",
    meta: statement_45errorQbRqjBCGhsMeta || {},
    alias: statement_45errorQbRqjBCGhsMeta?.alias || [],
    redirect: statement_45errorQbRqjBCGhsMeta?.redirect,
    component: () => import("/frontend/pages/documents/statement-error.vue").then(m => m.default || m)
  },
  {
    name: sync_45errorjFh9EXdvwbMeta?.name ?? "documents-sync-error",
    path: sync_45errorjFh9EXdvwbMeta?.path ?? "sync-error",
    meta: sync_45errorjFh9EXdvwbMeta || {},
    alias: sync_45errorjFh9EXdvwbMeta?.alias || [],
    redirect: sync_45errorjFh9EXdvwbMeta?.redirect,
    component: () => import("/frontend/pages/documents/sync-error.vue").then(m => m.default || m)
  },
  {
    name: syncnpIKBVbFQ2Meta?.name ?? "documents-sync",
    path: syncnpIKBVbFQ2Meta?.path ?? "sync",
    meta: syncnpIKBVbFQ2Meta || {},
    alias: syncnpIKBVbFQ2Meta?.alias || [],
    redirect: syncnpIKBVbFQ2Meta?.redirect,
    component: () => import("/frontend/pages/documents/sync.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91error_93dvDgwrqXJrMeta?.name ?? "embedded-error",
    path: _91error_93dvDgwrqXJrMeta?.path ?? "/embedded/:error()",
    meta: _91error_93dvDgwrqXJrMeta || {},
    alias: _91error_93dvDgwrqXJrMeta?.alias || [],
    redirect: _91error_93dvDgwrqXJrMeta?.redirect,
    component: () => import("/frontend/pages/embedded/[error].vue").then(m => m.default || m)
  },
  {
    name: business_45info7yDaQxvmOMMeta?.name ?? "embedded-business-info",
    path: business_45info7yDaQxvmOMMeta?.path ?? "/embedded/business-info",
    meta: business_45info7yDaQxvmOMMeta || {},
    alias: business_45info7yDaQxvmOMMeta?.alias || [],
    redirect: business_45info7yDaQxvmOMMeta?.redirect,
    component: () => import("/frontend/pages/embedded/business-info.vue").then(m => m.default || m)
  },
  {
    name: credit_45check_45result1Z4e49d7ThMeta?.name ?? "embedded-credit-check-result",
    path: credit_45check_45result1Z4e49d7ThMeta?.path ?? "/embedded/credit-check-result",
    meta: credit_45check_45result1Z4e49d7ThMeta || {},
    alias: credit_45check_45result1Z4e49d7ThMeta?.alias || [],
    redirect: credit_45check_45result1Z4e49d7ThMeta?.redirect,
    component: () => import("/frontend/pages/embedded/credit-check-result.vue").then(m => m.default || m)
  },
  {
    name: credit_45check3Awa0aP5EAMeta?.name ?? "embedded-credit-check",
    path: credit_45check3Awa0aP5EAMeta?.path ?? "/embedded/credit-check",
    meta: credit_45check3Awa0aP5EAMeta || {},
    alias: credit_45check3Awa0aP5EAMeta?.alias || [],
    redirect: credit_45check3Awa0aP5EAMeta?.redirect,
    component: () => import("/frontend/pages/embedded/credit-check.vue").then(m => m.default || m)
  },
  {
    name: documentsUQeA57NRfBMeta?.name ?? undefined,
    path: documentsUQeA57NRfBMeta?.path ?? "/embedded/documents",
    meta: documentsUQeA57NRfBMeta || {},
    alias: documentsUQeA57NRfBMeta?.alias || [],
    redirect: documentsUQeA57NRfBMeta?.redirect,
    component: () => import("/frontend/pages/embedded/documents.vue").then(m => m.default || m),
    children: [
  {
    name: accountsEkSb1nVWz6Meta?.name ?? "embedded-documents-accounts",
    path: accountsEkSb1nVWz6Meta?.path ?? "accounts",
    meta: accountsEkSb1nVWz6Meta || {},
    alias: accountsEkSb1nVWz6Meta?.alias || [],
    redirect: accountsEkSb1nVWz6Meta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/accounts.vue").then(m => m.default || m)
  },
  {
    name: indexdD0CTBRNpPMeta?.name ?? "embedded-documents",
    path: indexdD0CTBRNpPMeta?.path ?? "",
    meta: indexdD0CTBRNpPMeta || {},
    alias: indexdD0CTBRNpPMeta?.alias || [],
    redirect: indexdD0CTBRNpPMeta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/index.vue").then(m => m.default || m)
  },
  {
    name: manualpKHG85MNwbMeta?.name ?? "embedded-documents-manual",
    path: manualpKHG85MNwbMeta?.path ?? "manual",
    meta: manualpKHG85MNwbMeta || {},
    alias: manualpKHG85MNwbMeta?.alias || [],
    redirect: manualpKHG85MNwbMeta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/manual.vue").then(m => m.default || m)
  },
  {
    name: resultshQLsm0iXzWMeta?.name ?? "embedded-documents-results",
    path: resultshQLsm0iXzWMeta?.path ?? "results",
    meta: resultshQLsm0iXzWMeta || {},
    alias: resultshQLsm0iXzWMeta?.alias || [],
    redirect: resultshQLsm0iXzWMeta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/results.vue").then(m => m.default || m)
  },
  {
    name: statement_45errorSkNtKkB1hQMeta?.name ?? "embedded-documents-statement-error",
    path: statement_45errorSkNtKkB1hQMeta?.path ?? "statement-error",
    meta: statement_45errorSkNtKkB1hQMeta || {},
    alias: statement_45errorSkNtKkB1hQMeta?.alias || [],
    redirect: statement_45errorSkNtKkB1hQMeta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/statement-error.vue").then(m => m.default || m)
  },
  {
    name: sync_45error9qRnqZAvlkMeta?.name ?? "embedded-documents-sync-error",
    path: sync_45error9qRnqZAvlkMeta?.path ?? "sync-error",
    meta: sync_45error9qRnqZAvlkMeta || {},
    alias: sync_45error9qRnqZAvlkMeta?.alias || [],
    redirect: sync_45error9qRnqZAvlkMeta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/sync-error.vue").then(m => m.default || m)
  },
  {
    name: synckoyPDKpwQ9Meta?.name ?? "embedded-documents-sync",
    path: synckoyPDKpwQ9Meta?.path ?? "sync",
    meta: synckoyPDKpwQ9Meta || {},
    alias: synckoyPDKpwQ9Meta?.alias || [],
    redirect: synckoyPDKpwQ9Meta?.redirect,
    component: () => import("/frontend/pages/embedded/documents/sync.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexchSby0TNSqMeta?.name ?? "embedded",
    path: indexchSby0TNSqMeta?.path ?? "/embedded",
    meta: indexchSby0TNSqMeta || {},
    alias: indexchSby0TNSqMeta?.alias || [],
    redirect: indexchSby0TNSqMeta?.redirect,
    component: () => import("/frontend/pages/embedded/index.vue").then(m => m.default || m)
  },
  {
    name: portalRSWM0J4ABqMeta?.name ?? undefined,
    path: portalRSWM0J4ABqMeta?.path ?? "/embedded/portal",
    meta: portalRSWM0J4ABqMeta || {},
    alias: portalRSWM0J4ABqMeta?.alias || [],
    redirect: portalRSWM0J4ABqMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal.vue").then(m => m.default || m),
    children: [
  {
    name: accountsAFWPCBFbYoMeta?.name ?? "embedded-portal-accounts",
    path: accountsAFWPCBFbYoMeta?.path ?? "accounts",
    meta: accountsAFWPCBFbYoMeta || {},
    alias: accountsAFWPCBFbYoMeta?.alias || [],
    redirect: accountsAFWPCBFbYoMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/accounts.vue").then(m => m.default || m)
  },
  {
    name: dashboardeh4LK1QW7WMeta?.name ?? "embedded-portal-dashboard",
    path: dashboardeh4LK1QW7WMeta?.path ?? "dashboard",
    meta: dashboardeh4LK1QW7WMeta || {},
    alias: dashboardeh4LK1QW7WMeta?.alias || [],
    redirect: dashboardeh4LK1QW7WMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/dashboard.vue").then(m => m.default || m)
  },
  {
    name: documentsHNhBpJpOPYMeta?.name ?? "embedded-portal-documents",
    path: documentsHNhBpJpOPYMeta?.path ?? "documents",
    meta: documentsHNhBpJpOPYMeta || {},
    alias: documentsHNhBpJpOPYMeta?.alias || [],
    redirect: documentsHNhBpJpOPYMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/documents.vue").then(m => m.default || m)
  },
  {
    name: indexDmmXcsu9TfMeta?.name ?? "embedded-portal",
    path: indexDmmXcsu9TfMeta?.path ?? "",
    meta: indexDmmXcsu9TfMeta || {},
    alias: indexDmmXcsu9TfMeta?.alias || [],
    redirect: indexDmmXcsu9TfMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/index.vue").then(m => m.default || m)
  },
  {
    name: resultsNwZBoLUC6GMeta?.name ?? "embedded-portal-results",
    path: resultsNwZBoLUC6GMeta?.path ?? "results",
    meta: resultsNwZBoLUC6GMeta || {},
    alias: resultsNwZBoLUC6GMeta?.alias || [],
    redirect: resultsNwZBoLUC6GMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/results.vue").then(m => m.default || m)
  },
  {
    name: statement_45errorwwGlXAmkTyMeta?.name ?? "embedded-portal-statement-error",
    path: statement_45errorwwGlXAmkTyMeta?.path ?? "statement-error",
    meta: statement_45errorwwGlXAmkTyMeta || {},
    alias: statement_45errorwwGlXAmkTyMeta?.alias || [],
    redirect: statement_45errorwwGlXAmkTyMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/statement-error.vue").then(m => m.default || m)
  },
  {
    name: sync_45errorQU1sEo7jEoMeta?.name ?? "embedded-portal-sync-error",
    path: sync_45errorQU1sEo7jEoMeta?.path ?? "sync-error",
    meta: sync_45errorQU1sEo7jEoMeta || {},
    alias: sync_45errorQU1sEo7jEoMeta?.alias || [],
    redirect: sync_45errorQU1sEo7jEoMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/sync-error.vue").then(m => m.default || m)
  },
  {
    name: syncmOoHkuBdlrMeta?.name ?? "embedded-portal-sync",
    path: syncmOoHkuBdlrMeta?.path ?? "sync",
    meta: syncmOoHkuBdlrMeta || {},
    alias: syncmOoHkuBdlrMeta?.alias || [],
    redirect: syncmOoHkuBdlrMeta?.redirect,
    component: () => import("/frontend/pages/embedded/portal/sync.vue").then(m => m.default || m)
  }
]
  },
  {
    name: submitSZwfFSA2H8Meta?.name ?? "embedded-submit",
    path: submitSZwfFSA2H8Meta?.path ?? "/embedded/submit",
    meta: submitSZwfFSA2H8Meta || {},
    alias: submitSZwfFSA2H8Meta?.alias || [],
    redirect: submitSZwfFSA2H8Meta?.redirect,
    component: () => import("/frontend/pages/embedded/submit.vue").then(m => m.default || m)
  },
  {
    name: basic_45info4merkD28IdMeta?.name ?? "erc-basic-info",
    path: basic_45info4merkD28IdMeta?.path ?? "/erc/basic-info",
    meta: basic_45info4merkD28IdMeta || {},
    alias: basic_45info4merkD28IdMeta?.alias || [],
    redirect: basic_45info4merkD28IdMeta?.redirect,
    component: () => import("/frontend/pages/erc/basic-info.vue").then(m => m.default || m)
  },
  {
    name: business_45infoVSzfnR0bL7Meta?.name ?? "erc-business-info",
    path: business_45infoVSzfnR0bL7Meta?.path ?? "/erc/business-info",
    meta: business_45infoVSzfnR0bL7Meta || {},
    alias: business_45infoVSzfnR0bL7Meta?.alias || [],
    redirect: business_45infoVSzfnR0bL7Meta?.redirect,
    component: () => import("/frontend/pages/erc/business-info.vue").then(m => m.default || m)
  },
  {
    name: checklistbBEB1DliLMMeta?.name ?? "erc-checklist",
    path: checklistbBEB1DliLMMeta?.path ?? "/erc/checklist",
    meta: checklistbBEB1DliLMMeta || {},
    alias: checklistbBEB1DliLMMeta?.alias || [],
    redirect: checklistbBEB1DliLMMeta?.redirect,
    component: () => import("/frontend/pages/erc/checklist.vue").then(m => m.default || m)
  },
  {
    name: final_45erc_45affiliatenZKRMbgpD7Meta?.name ?? "erc-final-erc-affiliate",
    path: final_45erc_45affiliatenZKRMbgpD7Meta?.path ?? "/erc/final-erc-affiliate",
    meta: final_45erc_45affiliatenZKRMbgpD7Meta || {},
    alias: final_45erc_45affiliatenZKRMbgpD7Meta?.alias || [],
    redirect: final_45erc_45affiliatenZKRMbgpD7Meta?.redirect,
    component: () => import("/frontend/pages/erc/final-erc-affiliate.vue").then(m => m.default || m)
  },
  {
    name: final_45ercQkymtmWRHcMeta?.name ?? "erc-final-erc",
    path: final_45ercQkymtmWRHcMeta?.path ?? "/erc/final-erc",
    meta: final_45ercQkymtmWRHcMeta || {},
    alias: final_45ercQkymtmWRHcMeta?.alias || [],
    redirect: final_45ercQkymtmWRHcMeta?.redirect,
    component: () => import("/frontend/pages/erc/final-erc.vue").then(m => m.default || m)
  },
  {
    name: government_45order_45infoB4rVQLNNpMMeta?.name ?? "erc-government-order-info",
    path: government_45order_45infoB4rVQLNNpMMeta?.path ?? "/erc/government-order-info",
    meta: government_45order_45infoB4rVQLNNpMMeta || {},
    alias: government_45order_45infoB4rVQLNNpMMeta?.alias || [],
    redirect: government_45order_45infoB4rVQLNNpMMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order-info.vue").then(m => m.default || m)
  },
  {
    name: capacity_45limitationCprQ3v93KzMeta?.name ?? "erc-government-order-capacity-limitation",
    path: capacity_45limitationCprQ3v93KzMeta?.path ?? "/erc/government-order/capacity-limitation",
    meta: capacity_45limitationCprQ3v93KzMeta || {},
    alias: capacity_45limitationCprQ3v93KzMeta?.alias || [],
    redirect: capacity_45limitationCprQ3v93KzMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/capacity-limitation.vue").then(m => m.default || m)
  },
  {
    name: government_45order_452NNizlhJ15WMeta?.name ?? "erc-government-order-government-order-2",
    path: government_45order_452NNizlhJ15WMeta?.path ?? "/erc/government-order/government-order-2",
    meta: government_45order_452NNizlhJ15WMeta || {},
    alias: government_45order_452NNizlhJ15WMeta?.alias || [],
    redirect: government_45order_452NNizlhJ15WMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/government-order-2.vue").then(m => m.default || m)
  },
  {
    name: government_45order_453H0xi2sed1uMeta?.name ?? "erc-government-order-government-order-3",
    path: government_45order_453H0xi2sed1uMeta?.path ?? "/erc/government-order/government-order-3",
    meta: government_45order_453H0xi2sed1uMeta || {},
    alias: government_45order_453H0xi2sed1uMeta?.alias || [],
    redirect: government_45order_453H0xi2sed1uMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/government-order-3.vue").then(m => m.default || m)
  },
  {
    name: in_45person_45meetings_45affected7FUMkgaPC9Meta?.name ?? "erc-government-order-in-person-meetings-affected",
    path: in_45person_45meetings_45affected7FUMkgaPC9Meta?.path ?? "/erc/government-order/in-person-meetings-affected",
    meta: in_45person_45meetings_45affected7FUMkgaPC9Meta || {},
    alias: in_45person_45meetings_45affected7FUMkgaPC9Meta?.alias || [],
    redirect: in_45person_45meetings_45affected7FUMkgaPC9Meta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/in-person-meetings-affected.vue").then(m => m.default || m)
  },
  {
    name: indexfQuox16s0SMeta?.name ?? "erc-government-order",
    path: indexfQuox16s0SMeta?.path ?? "/erc/government-order",
    meta: indexfQuox16s0SMeta || {},
    alias: indexfQuox16s0SMeta?.alias || [],
    redirect: indexfQuox16s0SMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/index.vue").then(m => m.default || m)
  },
  {
    name: prevented_45customer_45accesszZpBd0OF0jMeta?.name ?? "erc-government-order-prevented-customer-access",
    path: prevented_45customer_45accesszZpBd0OF0jMeta?.path ?? "/erc/government-order/prevented-customer-access",
    meta: prevented_45customer_45accesszZpBd0OF0jMeta || {},
    alias: prevented_45customer_45accesszZpBd0OF0jMeta?.alias || [],
    redirect: prevented_45customer_45accesszZpBd0OF0jMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/prevented-customer-access.vue").then(m => m.default || m)
  },
  {
    name: production_45declinedumr2nJVMAzMeta?.name ?? "erc-government-order-production-declined",
    path: production_45declinedumr2nJVMAzMeta?.path ?? "/erc/government-order/production-declined",
    meta: production_45declinedumr2nJVMAzMeta || {},
    alias: production_45declinedumr2nJVMAzMeta?.alias || [],
    redirect: production_45declinedumr2nJVMAzMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/production-declined.vue").then(m => m.default || m)
  },
  {
    name: projects_45affectedYhvi9fm73wMeta?.name ?? "erc-government-order-projects-affected",
    path: projects_45affectedYhvi9fm73wMeta?.path ?? "/erc/government-order/projects-affected",
    meta: projects_45affectedYhvi9fm73wMeta || {},
    alias: projects_45affectedYhvi9fm73wMeta?.alias || [],
    redirect: projects_45affectedYhvi9fm73wMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/projects-affected.vue").then(m => m.default || m)
  },
  {
    name: reduced_45hours2L9fpKYR6vMeta?.name ?? "erc-government-order-reduced-hours",
    path: reduced_45hours2L9fpKYR6vMeta?.path ?? "/erc/government-order/reduced-hours",
    meta: reduced_45hours2L9fpKYR6vMeta || {},
    alias: reduced_45hours2L9fpKYR6vMeta?.alias || [],
    redirect: reduced_45hours2L9fpKYR6vMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/reduced-hours.vue").then(m => m.default || m)
  },
  {
    name: reduction_45in_45contractsbBqn6S9CmwMeta?.name ?? "erc-government-order-reduction-in-contracts",
    path: reduction_45in_45contractsbBqn6S9CmwMeta?.path ?? "/erc/government-order/reduction-in-contracts",
    meta: reduction_45in_45contractsbBqn6S9CmwMeta || {},
    alias: reduction_45in_45contractsbBqn6S9CmwMeta?.alias || [],
    redirect: reduction_45in_45contractsbBqn6S9CmwMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/reduction-in-contracts.vue").then(m => m.default || m)
  },
  {
    name: reduction_45in_45customers_45servedTEqUKeXS0lMeta?.name ?? "erc-government-order-reduction-in-customers-served",
    path: reduction_45in_45customers_45servedTEqUKeXS0lMeta?.path ?? "/erc/government-order/reduction-in-customers-served",
    meta: reduction_45in_45customers_45servedTEqUKeXS0lMeta || {},
    alias: reduction_45in_45customers_45servedTEqUKeXS0lMeta?.alias || [],
    redirect: reduction_45in_45customers_45servedTEqUKeXS0lMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/reduction-in-customers-served.vue").then(m => m.default || m)
  },
  {
    name: sales_45reducedhRQF654dqxMeta?.name ?? "erc-government-order-sales-reduced",
    path: sales_45reducedhRQF654dqxMeta?.path ?? "/erc/government-order/sales-reduced",
    meta: sales_45reducedhRQF654dqxMeta || {},
    alias: sales_45reducedhRQF654dqxMeta?.alias || [],
    redirect: sales_45reducedhRQF654dqxMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/sales-reduced.vue").then(m => m.default || m)
  },
  {
    name: staggered_45shiftsc1OL68XoaYMeta?.name ?? "erc-government-order-staggered-shifts",
    path: staggered_45shiftsc1OL68XoaYMeta?.path ?? "/erc/government-order/staggered-shifts",
    meta: staggered_45shiftsc1OL68XoaYMeta || {},
    alias: staggered_45shiftsc1OL68XoaYMeta?.alias || [],
    redirect: staggered_45shiftsc1OL68XoaYMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/staggered-shifts.vue").then(m => m.default || m)
  },
  {
    name: suppliers_45shutdowni8psYV1XZKMeta?.name ?? "erc-government-order-suppliers-shutdown",
    path: suppliers_45shutdowni8psYV1XZKMeta?.path ?? "/erc/government-order/suppliers-shutdown",
    meta: suppliers_45shutdowni8psYV1XZKMeta || {},
    alias: suppliers_45shutdowni8psYV1XZKMeta?.alias || [],
    redirect: suppliers_45shutdowni8psYV1XZKMeta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/suppliers-shutdown.vue").then(m => m.default || m)
  },
  {
    name: workspace_45modificationsRYUF1tRG78Meta?.name ?? "erc-government-order-workspace-modifications",
    path: workspace_45modificationsRYUF1tRG78Meta?.path ?? "/erc/government-order/workspace-modifications",
    meta: workspace_45modificationsRYUF1tRG78Meta || {},
    alias: workspace_45modificationsRYUF1tRG78Meta?.alias || [],
    redirect: workspace_45modificationsRYUF1tRG78Meta?.redirect,
    component: () => import("/frontend/pages/erc/government-order/workspace-modifications.vue").then(m => m.default || m)
  },
  {
    name: grant_45credit_45infoar4B8tPj4rMeta?.name ?? "erc-grant-credit-info",
    path: grant_45credit_45infoar4B8tPj4rMeta?.path ?? "/erc/grant-credit-info",
    meta: grant_45credit_45infoar4B8tPj4rMeta || {},
    alias: grant_45credit_45infoar4B8tPj4rMeta?.alias || [],
    redirect: grant_45credit_45infoar4B8tPj4rMeta?.redirect,
    component: () => import("/frontend/pages/erc/grant-credit-info.vue").then(m => m.default || m)
  },
  {
    name: indexIVXhYbD5PfMeta?.name ?? "erc",
    path: indexIVXhYbD5PfMeta?.path ?? "/erc",
    meta: indexIVXhYbD5PfMeta || {},
    alias: indexIVXhYbD5PfMeta?.alias || [],
    redirect: indexIVXhYbD5PfMeta?.redirect,
    component: () => import("/frontend/pages/erc/index.vue").then(m => m.default || m)
  },
  {
    name: ownership_45info_45tenantdpdPrhXxSdMeta?.name ?? "erc-ownership-info-tenant",
    path: ownership_45info_45tenantdpdPrhXxSdMeta?.path ?? "/erc/ownership-info-tenant",
    meta: ownership_45info_45tenantdpdPrhXxSdMeta || {},
    alias: ownership_45info_45tenantdpdPrhXxSdMeta?.alias || [],
    redirect: ownership_45info_45tenantdpdPrhXxSdMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info-tenant.vue").then(m => m.default || m)
  },
  {
    name: additional_45businessesAu71Ek6tpMMeta?.name ?? "erc-ownership-info-additional-businesses",
    path: additional_45businessesAu71Ek6tpMMeta?.path ?? "/erc/ownership-info/additional-businesses",
    meta: additional_45businessesAu71Ek6tpMMeta || {},
    alias: additional_45businessesAu71Ek6tpMMeta?.alias || [],
    redirect: additional_45businessesAu71Ek6tpMMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info/additional-businesses.vue").then(m => m.default || m)
  },
  {
    name: indexjsZCXVCdDAMeta?.name ?? "erc-ownership-info",
    path: indexjsZCXVCdDAMeta?.path ?? "/erc/ownership-info",
    meta: indexjsZCXVCdDAMeta || {},
    alias: indexjsZCXVCdDAMeta?.alias || [],
    redirect: indexjsZCXVCdDAMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info/index.vue").then(m => m.default || m)
  },
  {
    name: owner_45related_45employeesZ0rbHal0oHMeta?.name ?? "erc-ownership-info-owner-related-employees",
    path: owner_45related_45employeesZ0rbHal0oHMeta?.path ?? "/erc/ownership-info/owner-related-employees",
    meta: owner_45related_45employeesZ0rbHal0oHMeta || {},
    alias: owner_45related_45employeesZ0rbHal0oHMeta?.alias || [],
    redirect: owner_45related_45employeesZ0rbHal0oHMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info/owner-related-employees.vue").then(m => m.default || m)
  },
  {
    name: ownership_45mixin0DCp25IDOlMeta?.name ?? "erc-ownership-info-ownership-mixin",
    path: ownership_45mixin0DCp25IDOlMeta?.path ?? "/erc/ownership-info/ownership-mixin",
    meta: ownership_45mixin0DCp25IDOlMeta || {},
    alias: ownership_45mixin0DCp25IDOlMeta?.alias || [],
    redirect: ownership_45mixin0DCp25IDOlMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info/ownership-mixin.js").then(m => m.default || m)
  },
  {
    name: related_45ownersyZN4OuGdxdMeta?.name ?? "erc-ownership-info-related-owners",
    path: related_45ownersyZN4OuGdxdMeta?.path ?? "/erc/ownership-info/related-owners",
    meta: related_45ownersyZN4OuGdxdMeta || {},
    alias: related_45ownersyZN4OuGdxdMeta?.alias || [],
    redirect: related_45ownersyZN4OuGdxdMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info/related-owners.vue").then(m => m.default || m)
  },
  {
    name: spouse_45owned_45businesseslgEf2OwPMoMeta?.name ?? "erc-ownership-info-spouse-owned-businesses",
    path: spouse_45owned_45businesseslgEf2OwPMoMeta?.path ?? "/erc/ownership-info/spouse-owned-businesses",
    meta: spouse_45owned_45businesseslgEf2OwPMoMeta || {},
    alias: spouse_45owned_45businesseslgEf2OwPMoMeta?.alias || [],
    redirect: spouse_45owned_45businesseslgEf2OwPMoMeta?.redirect,
    component: () => import("/frontend/pages/erc/ownership-info/spouse-owned-businesses.vue").then(m => m.default || m)
  },
  {
    name: partner_45ercuVNtPYU8IvMeta?.name ?? "erc-partner-erc",
    path: partner_45ercuVNtPYU8IvMeta?.path ?? "/erc/partner-erc",
    meta: partner_45ercuVNtPYU8IvMeta || {},
    alias: partner_45ercuVNtPYU8IvMeta?.alias || [],
    redirect: partner_45ercuVNtPYU8IvMeta?.redirect,
    component: () => import("/frontend/pages/erc/partner-erc.vue").then(m => m.default || m)
  },
  {
    name: indexcf3nMXJwZkMeta?.name ?? "erc-payroll",
    path: indexcf3nMXJwZkMeta?.path ?? "/erc/payroll",
    meta: indexcf3nMXJwZkMeta || {},
    alias: indexcf3nMXJwZkMeta?.alias || [],
    redirect: indexcf3nMXJwZkMeta?.redirect,
    component: () => import("/frontend/pages/erc/payroll/index.vue").then(m => m.default || m)
  },
  {
    name: manualpXLgbEnlHZMeta?.name ?? "erc-payroll-manual",
    path: manualpXLgbEnlHZMeta?.path ?? "/erc/payroll/manual",
    meta: manualpXLgbEnlHZMeta || {},
    alias: manualpXLgbEnlHZMeta?.alias || [],
    redirect: manualpXLgbEnlHZMeta?.redirect,
    component: () => import("/frontend/pages/erc/payroll/manual.vue").then(m => m.default || m)
  },
  {
    name: peo_45infoqETSjFk6vrMeta?.name ?? "erc-peo-info",
    path: peo_45infoqETSjFk6vrMeta?.path ?? "/erc/peo-info",
    meta: peo_45infoqETSjFk6vrMeta || {},
    alias: peo_45infoqETSjFk6vrMeta?.alias || [],
    redirect: peo_45infoqETSjFk6vrMeta?.redirect,
    component: () => import("/frontend/pages/erc/peo-info.vue").then(m => m.default || m)
  },
  {
    name: ppp_45infoTdCb4t55A3Meta?.name ?? "erc-ppp-info",
    path: ppp_45infoTdCb4t55A3Meta?.path ?? "/erc/ppp-info",
    meta: ppp_45infoTdCb4t55A3Meta || {},
    alias: ppp_45infoTdCb4t55A3Meta?.alias || [],
    redirect: ppp_45infoTdCb4t55A3Meta?.redirect,
    component: () => import("/frontend/pages/erc/ppp-info.vue").then(m => m.default || m)
  },
  {
    name: qualificationsP6nxDqI4rTMeta?.name ?? "erc-qualifications",
    path: qualificationsP6nxDqI4rTMeta?.path ?? "/erc/qualifications",
    meta: qualificationsP6nxDqI4rTMeta || {},
    alias: qualificationsP6nxDqI4rTMeta?.alias || [],
    redirect: qualificationsP6nxDqI4rTMeta?.redirect,
    component: () => import("/frontend/pages/erc/qualifications.vue").then(m => m.default || m)
  },
  {
    name: revenue_45info6FohQ6COgdMeta?.name ?? "erc-revenue-info",
    path: revenue_45info6FohQ6COgdMeta?.path ?? "/erc/revenue-info",
    meta: revenue_45info6FohQ6COgdMeta || {},
    alias: revenue_45info6FohQ6COgdMeta?.alias || [],
    redirect: revenue_45info6FohQ6COgdMeta?.redirect,
    component: () => import("/frontend/pages/erc/revenue-info.vue").then(m => m.default || m)
  },
  {
    name: tax_45documentsHtRnLUX9PtMeta?.name ?? "erc-tax-documents",
    path: tax_45documentsHtRnLUX9PtMeta?.path ?? "/erc/tax-documents",
    meta: tax_45documentsHtRnLUX9PtMeta || {},
    alias: tax_45documentsHtRnLUX9PtMeta?.alias || [],
    redirect: tax_45documentsHtRnLUX9PtMeta?.redirect,
    component: () => import("/frontend/pages/erc/tax-documents.vue").then(m => m.default || m)
  },
  {
    name: _91identifier_93FVM4rVYc0dMeta?.name ?? "form-identifier",
    path: _91identifier_93FVM4rVYc0dMeta?.path ?? "/form/:identifier()",
    meta: _91identifier_93FVM4rVYc0dMeta || {},
    alias: _91identifier_93FVM4rVYc0dMeta?.alias || [],
    redirect: _91identifier_93FVM4rVYc0dMeta?.redirect,
    component: () => import("/frontend/pages/form/[identifier].vue").then(m => m.default || m),
    children: [
  {
    name: _91_91slug_93_939TAq515AaeMeta?.name ?? "form-identifier-slug",
    path: _91_91slug_93_939TAq515AaeMeta?.path ?? ":slug?",
    meta: _91_91slug_93_939TAq515AaeMeta || {},
    alias: _91_91slug_93_939TAq515AaeMeta?.alias || [],
    redirect: _91_91slug_93_939TAq515AaeMeta?.redirect,
    component: () => import("/frontend/pages/form/[identifier]/[[slug]].vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexPu9Tcx6ecrMeta?.name ?? "form",
    path: indexPu9Tcx6ecrMeta?.path ?? "/form",
    meta: indexPu9Tcx6ecrMeta || {},
    alias: indexPu9Tcx6ecrMeta?.alias || [],
    redirect: indexPu9Tcx6ecrMeta?.redirect,
    component: () => import("/frontend/pages/form/index.vue").then(m => m.default || m)
  },
  {
    name: indexHkHAubw5j8Meta?.name ?? "funding-needs",
    path: indexHkHAubw5j8Meta?.path ?? "/funding-needs",
    meta: indexHkHAubw5j8Meta || {},
    alias: indexHkHAubw5j8Meta?.alias || [],
    redirect: indexHkHAubw5j8Meta?.redirect,
    component: () => import("/frontend/pages/funding-needs/index.vue").then(m => m.default || m)
  },
  {
    name: healthcheckbv1LGjf6NUMeta?.name ?? "healthcheck",
    path: healthcheckbv1LGjf6NUMeta?.path ?? "/healthcheck",
    meta: healthcheckbv1LGjf6NUMeta || {},
    alias: healthcheckbv1LGjf6NUMeta?.alias || [],
    redirect: healthcheckbv1LGjf6NUMeta?.redirect,
    component: () => import("/frontend/pages/healthcheck.vue").then(m => m.default || m)
  },
  {
    name: indexJfWOMM8EtJMeta?.name ?? "intelligent-lending",
    path: indexJfWOMM8EtJMeta?.path ?? "/intelligent-lending",
    meta: indexJfWOMM8EtJMeta || {},
    alias: indexJfWOMM8EtJMeta?.alias || [],
    redirect: indexJfWOMM8EtJMeta?.redirect,
    component: () => import("/frontend/pages/intelligent-lending/index.vue").then(m => m.default || m)
  },
  {
    name: portalhqQ0UlkrPyMeta?.name ?? undefined,
    path: portalhqQ0UlkrPyMeta?.path ?? "/intelligent-lending/portal",
    meta: portalhqQ0UlkrPyMeta || {},
    alias: portalhqQ0UlkrPyMeta?.alias || [],
    redirect: portalhqQ0UlkrPyMeta?.redirect,
    component: () => import("/frontend/pages/intelligent-lending/portal.vue").then(m => m.default || m),
    children: [
  {
    name: dashboardSeKN9pUciRMeta?.name ?? "intelligent-lending-portal-dashboard",
    path: dashboardSeKN9pUciRMeta?.path ?? "dashboard",
    meta: dashboardSeKN9pUciRMeta || {},
    alias: dashboardSeKN9pUciRMeta?.alias || [],
    redirect: dashboardSeKN9pUciRMeta?.redirect,
    component: () => import("/frontend/pages/intelligent-lending/portal/dashboard.vue").then(m => m.default || m)
  },
  {
    name: documentsIzMRM2gVbsMeta?.name ?? "intelligent-lending-portal-documents",
    path: documentsIzMRM2gVbsMeta?.path ?? "documents",
    meta: documentsIzMRM2gVbsMeta || {},
    alias: documentsIzMRM2gVbsMeta?.alias || [],
    redirect: documentsIzMRM2gVbsMeta?.redirect,
    component: () => import("/frontend/pages/intelligent-lending/portal/documents.vue").then(m => m.default || m)
  },
  {
    name: indexbkxclBPk6qMeta?.name ?? "intelligent-lending-portal",
    path: indexbkxclBPk6qMeta?.path ?? "",
    meta: indexbkxclBPk6qMeta || {},
    alias: indexbkxclBPk6qMeta?.alias || [],
    redirect: indexbkxclBPk6qMeta?.redirect,
    component: () => import("/frontend/pages/intelligent-lending/portal/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: lender_45review94KxSNVaeEMeta?.name ?? "lender-review",
    path: lender_45review94KxSNVaeEMeta?.path ?? "/lender-review",
    meta: lender_45review94KxSNVaeEMeta || {},
    alias: lender_45review94KxSNVaeEMeta?.alias || [],
    redirect: lender_45review94KxSNVaeEMeta?.redirect,
    component: () => import("/frontend/pages/lender-review.vue").then(m => m.default || m)
  },
  {
    name: login_45errorPBF9SWGCCQMeta?.name ?? "login-error",
    path: login_45errorPBF9SWGCCQMeta?.path ?? "/login-error",
    meta: login_45errorPBF9SWGCCQMeta || {},
    alias: login_45errorPBF9SWGCCQMeta?.alias || [],
    redirect: login_45errorPBF9SWGCCQMeta?.redirect,
    component: () => import("/frontend/pages/login-error.vue").then(m => m.default || m)
  },
  {
    name: login_45ssothNWmAfhDJMeta?.name ?? "login-sso",
    path: login_45ssothNWmAfhDJMeta?.path ?? "/login-sso",
    meta: login_45ssothNWmAfhDJMeta || {},
    alias: login_45ssothNWmAfhDJMeta?.alias || [],
    redirect: login_45ssothNWmAfhDJMeta?.redirect,
    component: () => import("/frontend/pages/login-sso.vue").then(m => m.default || m)
  },
  {
    name: login8M9opu3hOuMeta?.name ?? "login",
    path: login8M9opu3hOuMeta?.path ?? "/login",
    meta: login8M9opu3hOuMeta || {},
    alias: login8M9opu3hOuMeta?.alias || [],
    redirect: login8M9opu3hOuMeta?.redirect,
    component: () => import("/frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: multiselect9a3Y25LZ1fMeta?.name ?? "multiselect",
    path: multiselect9a3Y25LZ1fMeta?.path ?? "/multiselect",
    meta: multiselect9a3Y25LZ1fMeta || {},
    alias: multiselect9a3Y25LZ1fMeta?.alias || [],
    redirect: multiselect9a3Y25LZ1fMeta?.redirect,
    component: () => import("/frontend/pages/multiselect.vue").then(m => m.default || m)
  },
  {
    name: newpassWcC54p5HkoMeta?.name ?? "newpass",
    path: newpassWcC54p5HkoMeta?.path ?? "/newpass",
    meta: newpassWcC54p5HkoMeta || {},
    alias: newpassWcC54p5HkoMeta?.alias || [],
    redirect: newpassWcC54p5HkoMeta?.redirect,
    component: () => import("/frontend/pages/newpass.vue").then(m => m.default || m)
  },
  {
    name: owner_45info2KYri6P3WaMeta?.name ?? undefined,
    path: owner_45info2KYri6P3WaMeta?.path ?? "/owner-info",
    meta: owner_45info2KYri6P3WaMeta || {},
    alias: owner_45info2KYri6P3WaMeta?.alias || [],
    redirect: owner_45info2KYri6P3WaMeta?.redirect,
    component: () => import("/frontend/pages/owner-info.vue").then(m => m.default || m),
    children: [
  {
    name: indexAn57psqaiqMeta?.name ?? "owner-info",
    path: indexAn57psqaiqMeta?.path ?? "",
    meta: indexAn57psqaiqMeta || {},
    alias: indexAn57psqaiqMeta?.alias || [],
    redirect: indexAn57psqaiqMeta?.redirect,
    component: () => import("/frontend/pages/owner-info/index.vue").then(m => m.default || m)
  },
  {
    name: owner_45info_452tSbNxPOGknMeta?.name ?? "owner-info-owner-info-2",
    path: owner_45info_452tSbNxPOGknMeta?.path ?? "owner-info-2",
    meta: owner_45info_452tSbNxPOGknMeta || {},
    alias: owner_45info_452tSbNxPOGknMeta?.alias || [],
    redirect: owner_45info_452tSbNxPOGknMeta?.redirect,
    component: () => import("/frontend/pages/owner-info/owner-info-2.vue").then(m => m.default || m)
  },
  {
    name: owner_45info_453Kn831IpHJtMeta?.name ?? "owner-info-owner-info-3",
    path: owner_45info_453Kn831IpHJtMeta?.path ?? "owner-info-3",
    meta: owner_45info_453Kn831IpHJtMeta || {},
    alias: owner_45info_453Kn831IpHJtMeta?.alias || [],
    redirect: owner_45info_453Kn831IpHJtMeta?.redirect,
    component: () => import("/frontend/pages/owner-info/owner-info-3.vue").then(m => m.default || m)
  },
  {
    name: owner_45info_454hTfGvm5Y3vMeta?.name ?? "owner-info-owner-info-4",
    path: owner_45info_454hTfGvm5Y3vMeta?.path ?? "owner-info-4",
    meta: owner_45info_454hTfGvm5Y3vMeta || {},
    alias: owner_45info_454hTfGvm5Y3vMeta?.alias || [],
    redirect: owner_45info_454hTfGvm5Y3vMeta?.redirect,
    component: () => import("/frontend/pages/owner-info/owner-info-4.vue").then(m => m.default || m)
  }
]
  },
  {
    name: portalR1NlEqQJ5wMeta?.name ?? undefined,
    path: portalR1NlEqQJ5wMeta?.path ?? "/portal",
    meta: portalR1NlEqQJ5wMeta || {},
    alias: portalR1NlEqQJ5wMeta?.alias || [],
    redirect: portalR1NlEqQJ5wMeta?.redirect,
    component: () => import("/frontend/pages/portal.vue").then(m => m.default || m),
    children: [
  {
    name: adjust_45offer0tKAHoVh63Meta?.name ?? "portal-adjust-offer",
    path: adjust_45offer0tKAHoVh63Meta?.path ?? "adjust-offer",
    meta: adjust_45offer0tKAHoVh63Meta || {},
    alias: adjust_45offer0tKAHoVh63Meta?.alias || [],
    redirect: adjust_45offer0tKAHoVh63Meta?.redirect,
    component: () => import("/frontend/pages/portal/adjust-offer.vue").then(m => m.default || m)
  },
  {
    name: business_45resourcesYIhoRNbZsVMeta?.name ?? "portal-business-resources",
    path: business_45resourcesYIhoRNbZsVMeta?.path ?? "business-resources",
    meta: business_45resourcesYIhoRNbZsVMeta || {},
    alias: business_45resourcesYIhoRNbZsVMeta?.alias || [],
    redirect: business_45resourcesYIhoRNbZsVMeta?.redirect,
    component: () => import("/frontend/pages/portal/business-resources.vue").then(m => m.default || m)
  },
  {
    name: closingXm5dRSFiQsMeta?.name ?? "portal-closing",
    path: closingXm5dRSFiQsMeta?.path ?? "closing",
    meta: closingXm5dRSFiQsMeta || {},
    alias: closingXm5dRSFiQsMeta?.alias || [],
    redirect: closingXm5dRSFiQsMeta?.redirect,
    component: () => import("/frontend/pages/portal/closing.vue").then(m => m.default || m)
  },
  {
    name: credit_45cardsq6uVui8cDqMeta?.name ?? "portal-credit-cards",
    path: credit_45cardsq6uVui8cDqMeta?.path ?? "credit-cards",
    meta: credit_45cardsq6uVui8cDqMeta || {},
    alias: credit_45cardsq6uVui8cDqMeta?.alias || [],
    redirect: credit_45cardsq6uVui8cDqMeta?.redirect,
    component: () => import("/frontend/pages/portal/credit-cards.vue").then(m => m.default || m)
  },
  {
    name: DnqCta5HrT2kA7GgMeta?.name ?? "portal-DnqCta",
    path: DnqCta5HrT2kA7GgMeta?.path ?? "DnqCta",
    meta: DnqCta5HrT2kA7GgMeta || {},
    alias: DnqCta5HrT2kA7GgMeta?.alias || [],
    redirect: DnqCta5HrT2kA7GgMeta?.redirect,
    component: () => import("/frontend/pages/portal/DnqCta.vue").then(m => m.default || m)
  },
  {
    name: documentsdPqoFiu7CmMeta?.name ?? "portal-documents",
    path: documentsdPqoFiu7CmMeta?.path ?? "documents",
    meta: documentsdPqoFiu7CmMeta || {},
    alias: documentsdPqoFiu7CmMeta?.alias || [],
    redirect: documentsdPqoFiu7CmMeta?.redirect,
    component: () => import("/frontend/pages/portal/documents.vue").then(m => m.default || m)
  },
  {
    name: explore_45other_45productsdpTSfVCcVpMeta?.name ?? "portal-explore-other-products",
    path: explore_45other_45productsdpTSfVCcVpMeta?.path ?? "explore-other-products",
    meta: explore_45other_45productsdpTSfVCcVpMeta || {},
    alias: explore_45other_45productsdpTSfVCcVpMeta?.alias || [],
    redirect: explore_45other_45productsdpTSfVCcVpMeta?.redirect,
    component: () => import("/frontend/pages/portal/explore-other-products.vue").then(m => m.default || m)
  },
  {
    name: indexF1HJUHW20QMeta?.name ?? "portal",
    path: indexF1HJUHW20QMeta?.path ?? "",
    meta: indexF1HJUHW20QMeta || {},
    alias: indexF1HJUHW20QMeta?.alias || [],
    redirect: indexF1HJUHW20QMeta?.redirect,
    component: () => import("/frontend/pages/portal/index.vue").then(m => m.default || m)
  },
  {
    name: loan_45offersFKsd2lfUxAMeta?.name ?? "portal-loan-offers",
    path: loan_45offersFKsd2lfUxAMeta?.path ?? "loan-offers",
    meta: loan_45offersFKsd2lfUxAMeta || {},
    alias: loan_45offersFKsd2lfUxAMeta?.alias || [],
    redirect: loan_45offersFKsd2lfUxAMeta?.redirect,
    component: () => import("/frontend/pages/portal/loan-offers.vue").then(m => m.default || m)
  },
  {
    name: offers_452_45confirmationnGGKyc9fc0Meta?.name ?? "portal-offers-2-confirmation",
    path: offers_452_45confirmationnGGKyc9fc0Meta?.path ?? "offers-2-confirmation",
    meta: offers_452_45confirmationnGGKyc9fc0Meta || {},
    alias: offers_452_45confirmationnGGKyc9fc0Meta?.alias || [],
    redirect: offers_452_45confirmationnGGKyc9fc0Meta?.redirect,
    component: () => import("/frontend/pages/portal/offers-2-confirmation.vue").then(m => m.default || m)
  },
  {
    name: offersz0LfXc9D2MMeta?.name ?? "portal-offers",
    path: offersz0LfXc9D2MMeta?.path ?? "offers",
    meta: offersz0LfXc9D2MMeta || {},
    alias: offersz0LfXc9D2MMeta?.alias || [],
    redirect: offersz0LfXc9D2MMeta?.redirect,
    component: () => import("/frontend/pages/portal/offers.vue").then(m => m.default || m)
  },
  {
    name: settings5sIbnpQoHEMeta?.name ?? "portal-settings",
    path: settings5sIbnpQoHEMeta?.path ?? "settings",
    meta: settings5sIbnpQoHEMeta || {},
    alias: settings5sIbnpQoHEMeta?.alias || [],
    redirect: settings5sIbnpQoHEMeta?.redirect,
    component: () => import("/frontend/pages/portal/settings.vue").then(m => m.default || m)
  },
  {
    name: sunrise_45appPIozIqG1FNMeta?.name ?? "portal-sunrise-app",
    path: sunrise_45appPIozIqG1FNMeta?.path ?? "sunrise-app",
    meta: sunrise_45appPIozIqG1FNMeta || {},
    alias: sunrise_45appPIozIqG1FNMeta?.alias || [],
    redirect: sunrise_45appPIozIqG1FNMeta?.redirect,
    component: () => import("/frontend/pages/portal/sunrise-app.vue").then(m => m.default || m)
  }
]
  },
  {
    name: pwf_45signupU2NgfyoH3zMeta?.name ?? "pwf-signup",
    path: pwf_45signupU2NgfyoH3zMeta?.path ?? "/pwf-signup",
    meta: pwf_45signupU2NgfyoH3zMeta || {},
    alias: pwf_45signupU2NgfyoH3zMeta?.alias || [],
    redirect: pwf_45signupU2NgfyoH3zMeta?.redirect,
    component: () => import("/frontend/pages/pwf-signup.vue").then(m => m.default || m)
  },
  {
    name: redirect_45from_45lendio63iIIqTkwVMeta?.name ?? "redirect-from-lendio",
    path: redirect_45from_45lendio63iIIqTkwVMeta?.path ?? "/redirect-from-lendio",
    meta: redirect_45from_45lendio63iIIqTkwVMeta || {},
    alias: redirect_45from_45lendio63iIIqTkwVMeta?.alias || [],
    redirect: redirect_45from_45lendio63iIIqTkwVMeta?.redirect,
    component: () => import("/frontend/pages/redirect-from-lendio.vue").then(m => m.default || m)
  },
  {
    name: _91rep_93i3HhxNXpUNMeta?.name ?? "referral-rep",
    path: _91rep_93i3HhxNXpUNMeta?.path ?? "/referral/:rep()",
    meta: _91rep_93i3HhxNXpUNMeta || {},
    alias: _91rep_93i3HhxNXpUNMeta?.alias || [],
    redirect: _91rep_93i3HhxNXpUNMeta?.redirect,
    component: () => import("/frontend/pages/referral/[rep].vue").then(m => m.default || m)
  },
  {
    name: thank_45youZv2ZsJW0QBMeta?.name ?? "referral-thank-you",
    path: thank_45youZv2ZsJW0QBMeta?.path ?? "/referral/thank-you",
    meta: thank_45youZv2ZsJW0QBMeta || {},
    alias: thank_45youZv2ZsJW0QBMeta?.alias || [],
    redirect: thank_45youZv2ZsJW0QBMeta?.redirect,
    component: () => import("/frontend/pages/referral/thank-you.vue").then(m => m.default || m)
  },
  {
    name: business_45infog69EM4f4MfMeta?.name ?? "renewal-business-info",
    path: business_45infog69EM4f4MfMeta?.path ?? "/renewal/business-info",
    meta: business_45infog69EM4f4MfMeta || {},
    alias: business_45infog69EM4f4MfMeta?.alias || [],
    redirect: business_45infog69EM4f4MfMeta?.redirect,
    component: () => import("/frontend/pages/renewal/business-info.vue").then(m => m.default || m)
  },
  {
    name: indexOF4KfvoBkjMeta?.name ?? "renewal-credit-check",
    path: indexOF4KfvoBkjMeta?.path ?? "/renewal/credit-check",
    meta: indexOF4KfvoBkjMeta || {},
    alias: indexOF4KfvoBkjMeta?.alias || [],
    redirect: indexOF4KfvoBkjMeta?.redirect,
    component: () => import("/frontend/pages/renewal/credit-check/index.vue").then(m => m.default || m)
  },
  {
    name: review86rwEbeEUCMeta?.name ?? "renewal-credit-check-review",
    path: review86rwEbeEUCMeta?.path ?? "/renewal/credit-check/review",
    meta: review86rwEbeEUCMeta || {},
    alias: review86rwEbeEUCMeta?.alias || [],
    redirect: review86rwEbeEUCMeta?.redirect,
    component: () => import("/frontend/pages/renewal/credit-check/review.vue").then(m => m.default || m)
  },
  {
    name: indexwuwXaQUxLKMeta?.name ?? "renewal-documents",
    path: indexwuwXaQUxLKMeta?.path ?? "/renewal/documents",
    meta: indexwuwXaQUxLKMeta || {},
    alias: indexwuwXaQUxLKMeta?.alias || [],
    redirect: indexwuwXaQUxLKMeta?.redirect,
    component: () => import("/frontend/pages/renewal/documents/index.vue").then(m => m.default || m)
  },
  {
    name: manualBKkdQ364iJMeta?.name ?? "renewal-documents-manual",
    path: manualBKkdQ364iJMeta?.path ?? "/renewal/documents/manual",
    meta: manualBKkdQ364iJMeta || {},
    alias: manualBKkdQ364iJMeta?.alias || [],
    redirect: manualBKkdQ364iJMeta?.redirect,
    component: () => import("/frontend/pages/renewal/documents/manual.vue").then(m => m.default || m)
  },
  {
    name: index54uuNy4VEFMeta?.name ?? "renewal",
    path: index54uuNy4VEFMeta?.path ?? "/renewal",
    meta: index54uuNy4VEFMeta || {},
    alias: index54uuNy4VEFMeta?.alias || [],
    redirect: index54uuNy4VEFMeta?.redirect,
    component: () => import("/frontend/pages/renewal/index.vue").then(m => m.default || m)
  },
  {
    name: new_45loan_45requirementsWGOaig5S9hMeta?.name ?? "renewal-new-loan-requirements",
    path: new_45loan_45requirementsWGOaig5S9hMeta?.path ?? "/renewal/new-loan-requirements",
    meta: new_45loan_45requirementsWGOaig5S9hMeta || {},
    alias: new_45loan_45requirementsWGOaig5S9hMeta?.alias || [],
    redirect: new_45loan_45requirementsWGOaig5S9hMeta?.redirect,
    component: () => import("/frontend/pages/renewal/new-loan-requirements.vue").then(m => m.default || m)
  },
  {
    name: submit3I3Js5gsuuMeta?.name ?? "renewal-submit",
    path: submit3I3Js5gsuuMeta?.path ?? "/renewal/submit",
    meta: submit3I3Js5gsuuMeta || {},
    alias: submit3I3Js5gsuuMeta?.alias || [],
    redirect: submit3I3Js5gsuuMeta?.redirect,
    component: () => import("/frontend/pages/renewal/submit.vue").then(m => m.default || m)
  },
  {
    name: resetu6sanXCFsXMeta?.name ?? "reset",
    path: resetu6sanXCFsXMeta?.path ?? "/reset",
    meta: resetu6sanXCFsXMeta || {},
    alias: resetu6sanXCFsXMeta?.alias || [],
    redirect: resetu6sanXCFsXMeta?.redirect,
    component: () => import("/frontend/pages/reset.vue").then(m => m.default || m)
  },
  {
    name: resume_45appH984Kab6AOMeta?.name ?? "resume-app",
    path: resume_45appH984Kab6AOMeta?.path ?? "/resume-app",
    meta: resume_45appH984Kab6AOMeta || {},
    alias: resume_45appH984Kab6AOMeta?.alias || [],
    redirect: resume_45appH984Kab6AOMeta?.redirect,
    component: () => import("/frontend/pages/resume-app.vue").then(m => m.default || m)
  },
  {
    name: rollbarGJN2plsEGFMeta?.name ?? "rollbar",
    path: rollbarGJN2plsEGFMeta?.path ?? "/rollbar",
    meta: rollbarGJN2plsEGFMeta || {},
    alias: rollbarGJN2plsEGFMeta?.alias || [],
    redirect: rollbarGJN2plsEGFMeta?.redirect,
    component: () => import("/frontend/pages/rollbar.vue").then(m => m.default || m)
  },
  {
    name: indexMQq7rtVUSrMeta?.name ?? "sba-complete",
    path: indexMQq7rtVUSrMeta?.path ?? "/sba-complete",
    meta: indexMQq7rtVUSrMeta || {},
    alias: indexMQq7rtVUSrMeta?.alias || [],
    redirect: indexMQq7rtVUSrMeta?.redirect,
    component: () => import("/frontend/pages/sba-complete/index.vue").then(m => m.default || m)
  },
  {
    name: documentsztADxtGTBZMeta?.name ?? "sba-complete-portal-documents",
    path: documentsztADxtGTBZMeta?.path ?? "/sba-complete/portal/documents",
    meta: documentsztADxtGTBZMeta || {},
    alias: documentsztADxtGTBZMeta?.alias || [],
    redirect: documentsztADxtGTBZMeta?.redirect,
    component: () => import("/frontend/pages/sba-complete/portal/documents.vue").then(m => m.default || m)
  },
  {
    name: indexZHNPdw7d0ZMeta?.name ?? "sba-complete-portal",
    path: indexZHNPdw7d0ZMeta?.path ?? "/sba-complete/portal",
    meta: indexZHNPdw7d0ZMeta || {},
    alias: indexZHNPdw7d0ZMeta?.alias || [],
    redirect: indexZHNPdw7d0ZMeta?.redirect,
    component: () => import("/frontend/pages/sba-complete/portal/index.vue").then(m => m.default || m)
  },
  {
    name: balance_45sheet1S6lYN2vmqMeta?.name ?? "sba-balance-sheet",
    path: balance_45sheet1S6lYN2vmqMeta?.path ?? "/sba/balance-sheet",
    meta: balance_45sheet1S6lYN2vmqMeta || {},
    alias: balance_45sheet1S6lYN2vmqMeta?.alias || [],
    redirect: balance_45sheet1S6lYN2vmqMeta?.redirect,
    component: () => import("/frontend/pages/sba/balance-sheet.vue").then(m => m.default || m)
  },
  {
    name: debt_45schedule_45uploadAlfTOxkjgwMeta?.name ?? "sba-debt-schedule-upload",
    path: debt_45schedule_45uploadAlfTOxkjgwMeta?.path ?? "/sba/debt-schedule-upload",
    meta: debt_45schedule_45uploadAlfTOxkjgwMeta || {},
    alias: debt_45schedule_45uploadAlfTOxkjgwMeta?.alias || [],
    redirect: debt_45schedule_45uploadAlfTOxkjgwMeta?.redirect,
    component: () => import("/frontend/pages/sba/debt-schedule-upload.vue").then(m => m.default || m)
  },
  {
    name: debt_45schedule9mdCCkYCK2Meta?.name ?? "sba-debt-schedule",
    path: debt_45schedule9mdCCkYCK2Meta?.path ?? "/sba/debt-schedule",
    meta: debt_45schedule9mdCCkYCK2Meta || {},
    alias: debt_45schedule9mdCCkYCK2Meta?.alias || [],
    redirect: debt_45schedule9mdCCkYCK2Meta?.redirect,
    component: () => import("/frontend/pages/sba/debt-schedule.vue").then(m => m.default || m)
  },
  {
    name: profit_45and_45lossDyKr3vKSKfMeta?.name ?? "sba-profit-and-loss",
    path: profit_45and_45lossDyKr3vKSKfMeta?.path ?? "/sba/profit-and-loss",
    meta: profit_45and_45lossDyKr3vKSKfMeta || {},
    alias: profit_45and_45lossDyKr3vKSKfMeta?.alias || [],
    redirect: profit_45and_45lossDyKr3vKSKfMeta?.redirect,
    component: () => import("/frontend/pages/sba/profit-and-loss.vue").then(m => m.default || m)
  },
  {
    name: tax_45returnsotxjqeb9AhMeta?.name ?? "sba-tax-returns",
    path: tax_45returnsotxjqeb9AhMeta?.path ?? "/sba/tax-returns",
    meta: tax_45returnsotxjqeb9AhMeta || {},
    alias: tax_45returnsotxjqeb9AhMeta?.alias || [],
    redirect: tax_45returnsotxjqeb9AhMeta?.redirect,
    component: () => import("/frontend/pages/sba/tax-returns.vue").then(m => m.default || m)
  },
  {
    name: sso_45signupOEO6xqeesmMeta?.name ?? "sso-signup",
    path: sso_45signupOEO6xqeesmMeta?.path ?? "/sso-signup",
    meta: sso_45signupOEO6xqeesmMeta || {},
    alias: sso_45signupOEO6xqeesmMeta?.alias || [],
    redirect: sso_45signupOEO6xqeesmMeta?.redirect,
    component: () => import("/frontend/pages/sso-signup.vue").then(m => m.default || m)
  },
  {
    name: submitBODkFOXSPpMeta?.name ?? "submit",
    path: submitBODkFOXSPpMeta?.path ?? "/submit",
    meta: submitBODkFOXSPpMeta || {},
    alias: submitBODkFOXSPpMeta?.alias || [],
    redirect: submitBODkFOXSPpMeta?.redirect,
    component: () => import("/frontend/pages/submit.vue").then(m => m.default || m)
  },
  {
    name: testjR5Xy3x4lTMeta?.name ?? "test",
    path: testjR5Xy3x4lTMeta?.path ?? "/test",
    meta: testjR5Xy3x4lTMeta || {},
    alias: testjR5Xy3x4lTMeta?.alias || [],
    redirect: testjR5Xy3x4lTMeta?.redirect,
    component: () => import("/frontend/pages/test.vue").then(m => m.default || m)
  },
  {
    name: tokenBO4C5yC0yNMeta?.name ?? "token",
    path: tokenBO4C5yC0yNMeta?.path ?? "/token",
    meta: tokenBO4C5yC0yNMeta || {},
    alias: tokenBO4C5yC0yNMeta?.alias || [],
    redirect: tokenBO4C5yC0yNMeta?.redirect,
    component: () => import("/frontend/pages/token.vue").then(m => m.default || m)
  },
  {
    name: under_45reviewmPSkg1xwVHMeta?.name ?? "under-review",
    path: under_45reviewmPSkg1xwVHMeta?.path ?? "/under-review",
    meta: under_45reviewmPSkg1xwVHMeta || {},
    alias: under_45reviewmPSkg1xwVHMeta?.alias || [],
    redirect: under_45reviewmPSkg1xwVHMeta?.redirect,
    component: () => import("/frontend/pages/under-review.vue").then(m => m.default || m)
  },
  {
    name: updated_45info7LsO9mvLTiMeta?.name ?? undefined,
    path: updated_45info7LsO9mvLTiMeta?.path ?? "/updated-info",
    meta: updated_45info7LsO9mvLTiMeta || {},
    alias: updated_45info7LsO9mvLTiMeta?.alias || [],
    redirect: updated_45info7LsO9mvLTiMeta?.redirect,
    component: () => import("/frontend/pages/updated-info.vue").then(m => m.default || m),
    children: [
  {
    name: indexv41VKvYPDOMeta?.name ?? "updated-info",
    path: indexv41VKvYPDOMeta?.path ?? "",
    meta: indexv41VKvYPDOMeta || {},
    alias: indexv41VKvYPDOMeta?.alias || [],
    redirect: indexv41VKvYPDOMeta?.redirect,
    component: () => import("/frontend/pages/updated-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: finicityvTSVc8gjY2Meta?.name ?? "upload-finicity",
    path: finicityvTSVc8gjY2Meta?.path ?? "/upload/finicity",
    meta: finicityvTSVc8gjY2Meta || {},
    alias: finicityvTSVc8gjY2Meta?.alias || [],
    redirect: finicityvTSVc8gjY2Meta?.redirect,
    component: () => import("/frontend/pages/upload/finicity.vue").then(m => m.default || m)
  },
  {
    name: indexvZohKRy7JmMeta?.name ?? "upload",
    path: indexvZohKRy7JmMeta?.path ?? "/upload",
    meta: indexvZohKRy7JmMeta || {},
    alias: indexvZohKRy7JmMeta?.alias || [],
    redirect: indexvZohKRy7JmMeta?.redirect,
    component: () => import("/frontend/pages/upload/index.vue").then(m => m.default || m)
  },
  {
    name: manualz1eH6QsiToMeta?.name ?? "upload-manual",
    path: manualz1eH6QsiToMeta?.path ?? "/upload/manual",
    meta: manualz1eH6QsiToMeta || {},
    alias: manualz1eH6QsiToMeta?.alias || [],
    redirect: manualz1eH6QsiToMeta?.redirect,
    component: () => import("/frontend/pages/upload/manual.vue").then(m => m.default || m)
  },
  {
    name: requestsTHo3oqd24tMeta?.name ?? "upload-requests",
    path: requestsTHo3oqd24tMeta?.path ?? "/upload/requests",
    meta: requestsTHo3oqd24tMeta || {},
    alias: requestsTHo3oqd24tMeta?.alias || [],
    redirect: requestsTHo3oqd24tMeta?.redirect,
    component: () => import("/frontend/pages/upload/requests.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailDl62eZnYUQMeta?.name ?? "verify-email",
    path: verify_45emailDl62eZnYUQMeta?.path ?? "/verify-email",
    meta: verify_45emailDl62eZnYUQMeta || {},
    alias: verify_45emailDl62eZnYUQMeta?.alias || [],
    redirect: verify_45emailDl62eZnYUQMeta?.redirect,
    component: () => import("/frontend/pages/verify-email.vue").then(m => m.default || m)
  },
  {
    name: waypoint_450B1SCUtwCcYMeta?.name ?? "waypoint-0",
    path: waypoint_450B1SCUtwCcYMeta?.path ?? "/waypoint-0",
    meta: waypoint_450B1SCUtwCcYMeta || {},
    alias: waypoint_450B1SCUtwCcYMeta?.alias || [],
    redirect: waypoint_450B1SCUtwCcYMeta?.redirect,
    component: () => import("/frontend/pages/waypoint-0.vue").then(m => m.default || m)
  },
  {
    name: waypoint_451v7Lt1D1z87Meta?.name ?? "waypoint-1",
    path: waypoint_451v7Lt1D1z87Meta?.path ?? "/waypoint-1",
    meta: waypoint_451v7Lt1D1z87Meta || {},
    alias: waypoint_451v7Lt1D1z87Meta?.alias || [],
    redirect: waypoint_451v7Lt1D1z87Meta?.redirect,
    component: () => import("/frontend/pages/waypoint-1.vue").then(m => m.default || m)
  },
  {
    name: basic_45infoDQJXFbq5CEMeta?.name ?? "sba-complete-basic-info",
    path: basic_45infoDQJXFbq5CEMeta?.path ?? "/sba-complete/basic-info",
    meta: basic_45infoDQJXFbq5CEMeta || {},
    alias: basic_45infoDQJXFbq5CEMeta?.alias || [],
    redirect: basic_45infoDQJXFbq5CEMeta?.redirect,
    component: () => import("~/pages/basic-info.vue").then(m => m.default || m)
  },
  {
    name: owner_45infocX1MkwIYvpMeta?.name ?? undefined,
    path: owner_45infocX1MkwIYvpMeta?.path ?? "/sba-complete/owner-info",
    meta: owner_45infocX1MkwIYvpMeta || {},
    alias: owner_45infocX1MkwIYvpMeta?.alias || [],
    redirect: owner_45infocX1MkwIYvpMeta?.redirect,
    component: () => import("~/pages/owner-info.vue").then(m => m.default || m),
    children: [
  {
    name: indexp05jsjiaBTMeta?.name ?? "sba-complete-owner-info",
    path: indexp05jsjiaBTMeta?.path ?? "",
    meta: indexp05jsjiaBTMeta || {},
    alias: indexp05jsjiaBTMeta?.alias || [],
    redirect: indexp05jsjiaBTMeta?.redirect,
    component: () => import("~/pages/owner-info/index.vue").then(m => m.default || m)
  },
  {
    name: owner_45info_452EvTXma01J1Meta?.name ?? "sba-complete-owner-info-2",
    path: owner_45info_452EvTXma01J1Meta?.path ?? "owner-info-2",
    meta: owner_45info_452EvTXma01J1Meta || {},
    alias: owner_45info_452EvTXma01J1Meta?.alias || [],
    redirect: owner_45info_452EvTXma01J1Meta?.redirect,
    component: () => import("~/pages/owner-info/owner-info-2.vue").then(m => m.default || m)
  },
  {
    name: owner_45info_4535fmFXPdRD4Meta?.name ?? "sba-complete-owner-info-3",
    path: owner_45info_4535fmFXPdRD4Meta?.path ?? "owner-info-3",
    meta: owner_45info_4535fmFXPdRD4Meta || {},
    alias: owner_45info_4535fmFXPdRD4Meta?.alias || [],
    redirect: owner_45info_4535fmFXPdRD4Meta?.redirect,
    component: () => import("~/pages/owner-info/owner-info-3.vue").then(m => m.default || m)
  }
]
  },
  {
    name: business_45infoWMSuu4bQfQMeta?.name ?? undefined,
    path: business_45infoWMSuu4bQfQMeta?.path ?? "/sba-complete/business-info",
    meta: business_45infoWMSuu4bQfQMeta || {},
    alias: business_45infoWMSuu4bQfQMeta?.alias || [],
    redirect: business_45infoWMSuu4bQfQMeta?.redirect,
    component: () => import("~/pages/business-info.vue").then(m => m.default || m),
    children: [
  {
    name: indexnWue2NkKc8Meta?.name ?? "sba-complete-business-info-1",
    path: indexnWue2NkKc8Meta?.path ?? "",
    meta: indexnWue2NkKc8Meta || {},
    alias: indexnWue2NkKc8Meta?.alias || [],
    redirect: indexnWue2NkKc8Meta?.redirect,
    component: () => import("~/pages/business-info/index.vue").then(m => m.default || m)
  },
  {
    name: business_45info_452pixnYywCPkMeta?.name ?? "sba-complete-business-info-2",
    path: business_45info_452pixnYywCPkMeta?.path ?? "business-info-2",
    meta: business_45info_452pixnYywCPkMeta || {},
    alias: business_45info_452pixnYywCPkMeta?.alias || [],
    redirect: business_45info_452pixnYywCPkMeta?.redirect,
    component: () => import("~/pages/business-info/business-info-2.vue").then(m => m.default || m)
  },
  {
    name: business_45info_4537WPrrOBWBiMeta?.name ?? "sba-complete-business-info-3",
    path: business_45info_4537WPrrOBWBiMeta?.path ?? "business-info-3",
    meta: business_45info_4537WPrrOBWBiMeta || {},
    alias: business_45info_4537WPrrOBWBiMeta?.alias || [],
    redirect: business_45info_4537WPrrOBWBiMeta?.redirect,
    component: () => import("~/pages/business-info/business-info-3.vue").then(m => m.default || m)
  }
]
  },
  {
    name: documentsSBpLC342UmMeta?.name ?? undefined,
    path: documentsSBpLC342UmMeta?.path ?? "/sba-complete/documents",
    meta: documentsSBpLC342UmMeta || {},
    alias: documentsSBpLC342UmMeta?.alias || [],
    redirect: documentsSBpLC342UmMeta?.redirect,
    component: () => import("~/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: indexMOOjPajTGGMeta?.name ?? "sba-complete-bank-statements",
    path: indexMOOjPajTGGMeta?.path ?? "",
    meta: indexMOOjPajTGGMeta || {},
    alias: indexMOOjPajTGGMeta?.alias || [],
    redirect: indexMOOjPajTGGMeta?.redirect,
    component: () => import("~/pages/documents/index.vue").then(m => m.default || m)
  },
  {
    name: accountsrMx7FFEkSsMeta?.name ?? "sba-complete-bank-statements-accounts",
    path: accountsrMx7FFEkSsMeta?.path ?? "accounts",
    meta: accountsrMx7FFEkSsMeta || {},
    alias: accountsrMx7FFEkSsMeta?.alias || [],
    redirect: accountsrMx7FFEkSsMeta?.redirect,
    component: () => import("~/pages/documents/accounts.vue").then(m => m.default || m)
  },
  {
    name: manual45bRhVj1d6Meta?.name ?? "sba-complete-bank-statements-manual",
    path: manual45bRhVj1d6Meta?.path ?? "manual",
    meta: manual45bRhVj1d6Meta || {},
    alias: manual45bRhVj1d6Meta?.alias || [],
    redirect: manual45bRhVj1d6Meta?.redirect,
    component: () => import("~/pages/documents/manual.vue").then(m => m.default || m)
  },
  {
    name: results7PbqIUioVBMeta?.name ?? "sba-complete-bank-statements-results",
    path: results7PbqIUioVBMeta?.path ?? "results",
    meta: results7PbqIUioVBMeta || {},
    alias: results7PbqIUioVBMeta?.alias || [],
    redirect: results7PbqIUioVBMeta?.redirect,
    component: () => import("~/pages/documents/results.vue").then(m => m.default || m)
  },
  {
    name: statement_45errorIi6aDKPvdBMeta?.name ?? "sba-complete-bank-statements-statement-error",
    path: statement_45errorIi6aDKPvdBMeta?.path ?? "statement-error",
    meta: statement_45errorIi6aDKPvdBMeta || {},
    alias: statement_45errorIi6aDKPvdBMeta?.alias || [],
    redirect: statement_45errorIi6aDKPvdBMeta?.redirect,
    component: () => import("~/pages/documents/statement-error.vue").then(m => m.default || m)
  },
  {
    name: sync_45errorfspmeCkScfMeta?.name ?? "sba-complete-bank-statements-sync-error",
    path: sync_45errorfspmeCkScfMeta?.path ?? "sync-error",
    meta: sync_45errorfspmeCkScfMeta || {},
    alias: sync_45errorfspmeCkScfMeta?.alias || [],
    redirect: sync_45errorfspmeCkScfMeta?.redirect,
    component: () => import("~/pages/documents/sync-error.vue").then(m => m.default || m)
  },
  {
    name: syncOcFHWDYP2RMeta?.name ?? "sba-complete-bank-statements-sync",
    path: syncOcFHWDYP2RMeta?.path ?? "sync",
    meta: syncOcFHWDYP2RMeta || {},
    alias: syncOcFHWDYP2RMeta?.alias || [],
    redirect: syncOcFHWDYP2RMeta?.redirect,
    component: () => import("~/pages/documents/sync.vue").then(m => m.default || m)
  }
]
  },
  {
    name: tax_45returnsglKvLKSewvMeta?.name ?? "sba-complete-tax-returns",
    path: tax_45returnsglKvLKSewvMeta?.path ?? "/sba-complete/tax-returns",
    meta: tax_45returnsglKvLKSewvMeta || {},
    alias: tax_45returnsglKvLKSewvMeta?.alias || [],
    redirect: tax_45returnsglKvLKSewvMeta?.redirect,
    component: () => import("~/pages/sba/tax-returns.vue").then(m => m.default || m)
  },
  {
    name: debt_45scheduleICMfs2VJXSMeta?.name ?? "sba-complete-debt-schedule",
    path: debt_45scheduleICMfs2VJXSMeta?.path ?? "/sba-complete/debt-schedule",
    meta: debt_45scheduleICMfs2VJXSMeta || {},
    alias: debt_45scheduleICMfs2VJXSMeta?.alias || [],
    redirect: debt_45scheduleICMfs2VJXSMeta?.redirect,
    component: () => import("~/pages/sba/debt-schedule.vue").then(m => m.default || m)
  },
  {
    name: debt_45schedule_45uploadKdnClmSlK7Meta?.name ?? "sba-complete-debt-schedule-upload",
    path: debt_45schedule_45uploadKdnClmSlK7Meta?.path ?? "/sba-complete/debt-schedule-upload",
    meta: debt_45schedule_45uploadKdnClmSlK7Meta || {},
    alias: debt_45schedule_45uploadKdnClmSlK7Meta?.alias || [],
    redirect: debt_45schedule_45uploadKdnClmSlK7Meta?.redirect,
    component: () => import("~/pages/sba/debt-schedule-upload.vue").then(m => m.default || m)
  },
  {
    name: profit_45and_45loss6KYt05WFPHMeta?.name ?? "sba-complete-profit-and-loss",
    path: profit_45and_45loss6KYt05WFPHMeta?.path ?? "/sba-complete/profit-and-loss",
    meta: profit_45and_45loss6KYt05WFPHMeta || {},
    alias: profit_45and_45loss6KYt05WFPHMeta?.alias || [],
    redirect: profit_45and_45loss6KYt05WFPHMeta?.redirect,
    component: () => import("~/pages/sba/profit-and-loss.vue").then(m => m.default || m)
  },
  {
    name: balance_45sheetcOMazjXBgiMeta?.name ?? "sba-complete-balance-sheet",
    path: balance_45sheetcOMazjXBgiMeta?.path ?? "/sba-complete/balance-sheet",
    meta: balance_45sheetcOMazjXBgiMeta || {},
    alias: balance_45sheetcOMazjXBgiMeta?.alias || [],
    redirect: balance_45sheetcOMazjXBgiMeta?.redirect,
    component: () => import("~/pages/sba/balance-sheet.vue").then(m => m.default || m)
  },
  {
    name: submit7M2ZAdLQ6OMeta?.name ?? "sba-complete-submit",
    path: submit7M2ZAdLQ6OMeta?.path ?? "/sba-complete/submit",
    meta: submit7M2ZAdLQ6OMeta || {},
    alias: submit7M2ZAdLQ6OMeta?.alias || [],
    redirect: submit7M2ZAdLQ6OMeta?.redirect,
    component: () => import("~/pages/embedded/submit.vue").then(m => m.default || m)
  }
]